var items = {
  "block.minecraft.acacia_button": "Voton ta akasia",
  "block.minecraft.acacia_door": "Ti'na ta akasia",
  "block.minecraft.acacia_fence": "Mok ta akasia",
  "block.minecraft.acacia_fence_gate": "Ti' mok ta akasia",
  "block.minecraft.acacia_hanging_sign": "Jipiej leterero ta akasia",
  "block.minecraft.acacia_leaves": "Yanaltak akasia",
  "block.minecraft.acacia_log": "Chumante' akasia",
  "block.minecraft.acacia_planks": "Tenelte'etik ta akasia",
  "block.minecraft.acacia_pressure_plate": "Net'obil ta akasia",
  "block.minecraft.acacia_sapling": "K'elom akasia",
  "block.minecraft.acacia_shelf": "Repisa ta akasia",
  "block.minecraft.acacia_sign": "Leterero ta akasia",
  "block.minecraft.acacia_slab": "Losa ta akasia",
  "block.minecraft.acacia_stairs": "Ixkalera ta akasia",
  "block.minecraft.acacia_trapdoor": "Ti' pets' ta akasia",
  "block.minecraft.acacia_wall_hanging_sign": "Jipiej leterero ta akasia ta kubo",
  "block.minecraft.acacia_wall_sign": "Leterero ta akasia ta kubo",
  "block.minecraft.acacia_wood": "Akasia te'",
  "block.minecraft.activator_rail": "Xanebal tsoyel",
  "block.minecraft.air": "Ik'",
  "block.minecraft.allium": "Tuixnichim",
  "block.minecraft.amethyst_block": "Kubo ta amatista",
  "block.minecraft.amethyst_cluster": "Tsobol amatista",
  "block.minecraft.ancient_debris": "Poko' k'osetik",
  "block.minecraft.andesite": "Antesita",
  "block.minecraft.andesite_slab": "Losa ta antesita",
  "block.minecraft.andesite_stairs": "Ixkalera ta antesita",
  "block.minecraft.andesite_wall": "Muro ta antesita",
  "block.minecraft.anvil": "Yunke",
  "block.minecraft.attached_melon_stem": "Kakal ch'ut xancha",
  "block.minecraft.attached_pumpkin_stem": "Kakal ch'ut ch'um",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Yanaltak asalea",
  "block.minecraft.azure_bluet": "Sakpak'an nichim",
  "block.minecraft.bamboo": "Ton-aj",
  "block.minecraft.bamboo_block": "Kubo ta ton-aj",
  "block.minecraft.bamboo_button": "Voton ta ton-aj",
  "block.minecraft.bamboo_door": "Ti'na ta ton-aj",
  "block.minecraft.bamboo_fence": "Mok ta ton-aj",
  "block.minecraft.bamboo_fence_gate": "Ti' mok ta ton-aj",
  "block.minecraft.bamboo_hanging_sign": "Jipiej leterero ta ton-aj",
  "block.minecraft.bamboo_mosaic": "Mosayko ta ton-aj",
  "block.minecraft.bamboo_mosaic_slab": "Losa ta mosayko ta ton-aj",
  "block.minecraft.bamboo_mosaic_stairs": "Ixkalera ta mosayko ta ton-aj",
  "block.minecraft.bamboo_planks": "Tenelte' ton-ajetik",
  "block.minecraft.bamboo_pressure_plate": "Net'obil ta ton-aj",
  "block.minecraft.bamboo_sapling": "K'elom ton-aj",
  "block.minecraft.bamboo_shelf": "Repisa ta ton-aj",
  "block.minecraft.bamboo_sign": "Leterero ta ton-aj",
  "block.minecraft.bamboo_slab": "Losa ta ton-aj",
  "block.minecraft.bamboo_stairs": "Ixkalera ta ton-aj",
  "block.minecraft.bamboo_trapdoor": "Ti' pets' ta ton-aj",
  "block.minecraft.bamboo_wall_hanging_sign": "Jipiej leterero ta ton-aj ta kubo",
  "block.minecraft.bamboo_wall_sign": "Leterero ta ton-aj ta kubo",
  "block.minecraft.banner.base.black": "Ik'al tajmek tela",
  "block.minecraft.banner.base.blue": "Yaxal tela",
  "block.minecraft.banner.base.brown": "K'anch'etan tela",
  "block.minecraft.banner.base.cyan": "Yax-elan tela",
  "block.minecraft.banner.base.gray": "K'anch'etan tela",
  "block.minecraft.banner.base.green": "Yaxal tela",
  "block.minecraft.banner.base.light_blue": "Yaxal tela",
  "block.minecraft.banner.base.light_gray": "K'anch'etan tela",
  "block.minecraft.banner.base.lime": "Yoxyoxtik tela",
  "block.minecraft.banner.base.magenta": "Tsojtsojtik tela",
  "block.minecraft.banner.base.orange": "K'onk'ontik tela",
  "block.minecraft.banner.base.pink": "Tsojtsojtik tela",
  "block.minecraft.banner.base.purple": "Ik'pok'an tela",
  "block.minecraft.banner.base.red": "Tsajal tela",
  "block.minecraft.banner.base.white": "Sakil tela",
  "block.minecraft.banner.base.yellow": "K'anal pok'al",
  "block.minecraft.banner.border.black": "Ik'al ti'il",
  "block.minecraft.banner.border.blue": "Yaxal ti'il",
  "block.minecraft.banner.border.brown": "K'anch'etan ti'il",
  "block.minecraft.banner.border.cyan": "Yax-elan ti'il",
  "block.minecraft.banner.border.gray": "K'anch'etan ti'il",
  "block.minecraft.banner.border.green": "Yaxal ti'il",
  "block.minecraft.banner.border.light_blue": "Yaxal ti'il",
  "block.minecraft.banner.border.light_gray": "K'anch'etan ti'il",
  "block.minecraft.banner.border.lime": "Yoxyoxtik ti'il",
  "block.minecraft.banner.border.magenta": "Tsojtsojtik ti'il",
  "block.minecraft.banner.border.orange": "K'onk'ontik ti'il",
  "block.minecraft.banner.border.pink": "Tsojtsojtik ti'il",
  "block.minecraft.banner.border.purple": "Ik'pok'an ti'il",
  "block.minecraft.banner.border.red": "Tsajal ti'il",
  "block.minecraft.banner.border.white": "Sakil ti'il",
  "block.minecraft.banner.border.yellow": "K'anal ti'il",
  "block.minecraft.banner.bricks.black": "Ik'al latriyoal",
  "block.minecraft.banner.bricks.blue": "Yaxal latriyoal",
  "block.minecraft.banner.bricks.brown": "K'anch'etan latriyoal",
  "block.minecraft.banner.bricks.cyan": "Yax-elan latriyoal",
  "block.minecraft.banner.bricks.gray": "K'anch'etan latriyoal",
  "block.minecraft.banner.bricks.green": "Yaxal latriyoal",
  "block.minecraft.banner.bricks.light_blue": "Yaxal latriyoal",
  "block.minecraft.banner.bricks.light_gray": "K'anch'etan latriyoal",
  "block.minecraft.banner.bricks.lime": "Yoxyoxtik latriyoal",
  "block.minecraft.banner.bricks.magenta": "Tsojtsojtik latriyoal",
  "block.minecraft.banner.bricks.orange": "K'onk'ontik latriyoal",
  "block.minecraft.banner.bricks.pink": "Tsojtsojtik latriyoal",
  "block.minecraft.banner.bricks.purple": "Ik'pok'an latriyoal",
  "block.minecraft.banner.bricks.red": "Tsajal latriyoal",
  "block.minecraft.banner.bricks.white": "Sakil latriyoal",
  "block.minecraft.banner.bricks.yellow": "K'anal latriyoal",
  "block.minecraft.banner.circle.black": "Ik'al setset",
  "block.minecraft.banner.circle.blue": "Yaxal setset",
  "block.minecraft.banner.circle.brown": "K'anch'etan setset",
  "block.minecraft.banner.circle.cyan": "Yax-elan setset",
  "block.minecraft.banner.circle.gray": "K'anch'etan setset",
  "block.minecraft.banner.circle.green": "Yaxal setset",
  "block.minecraft.banner.circle.light_blue": "Yaxal setset",
  "block.minecraft.banner.circle.light_gray": "K'anch'etan setset",
  "block.minecraft.banner.circle.lime": "Yoxyoxtik setset",
  "block.minecraft.banner.circle.magenta": "Tsojtsojtik setset",
  "block.minecraft.banner.circle.orange": "K'onk'ontik setset",
  "block.minecraft.banner.circle.pink": "Tsojtsojtik setset",
  "block.minecraft.banner.circle.purple": "Ik'pok'an setset",
  "block.minecraft.banner.circle.red": "Tsajal setset",
  "block.minecraft.banner.circle.white": "Sakil setset",
  "block.minecraft.banner.circle.yellow": "K'anal setset",
  "block.minecraft.banner.creeper.black": "Ik'al creeper",
  "block.minecraft.banner.creeper.blue": "Yaxal creeper",
  "block.minecraft.banner.creeper.brown": "K'anch'etan creeper",
  "block.minecraft.banner.creeper.cyan": "Yax-elan creeper",
  "block.minecraft.banner.creeper.gray": "K'anch'etan creeper",
  "block.minecraft.banner.creeper.green": "Yaxal creeper",
  "block.minecraft.banner.creeper.light_blue": "Yaxal creeper",
  "block.minecraft.banner.creeper.light_gray": "K'anch'etan creeper",
  "block.minecraft.banner.creeper.lime": "Yoxyoxtik creeper",
  "block.minecraft.banner.creeper.magenta": "Tsojtsojtik creeper",
  "block.minecraft.banner.creeper.orange": "K'onk'ontik creeper",
  "block.minecraft.banner.creeper.pink": "Tsojtsojtik creeper",
  "block.minecraft.banner.creeper.purple": "Ik'pok'an creeper",
  "block.minecraft.banner.creeper.red": "Tsajal creeper",
  "block.minecraft.banner.creeper.white": "Sakil creeper",
  "block.minecraft.banner.creeper.yellow": "K'anal creeper",
  "block.minecraft.banner.cross.black": "Ik'al sovter",
  "block.minecraft.banner.cross.blue": "Yaxal sovter",
  "block.minecraft.banner.cross.brown": "K'anch'etan sovter",
  "block.minecraft.banner.cross.cyan": "Yax-elan sovter",
  "block.minecraft.banner.cross.gray": "K'anch'etan sovter",
  "block.minecraft.banner.cross.green": "Yaxal sovter",
  "block.minecraft.banner.cross.light_blue": "Yaxal sovter",
  "block.minecraft.banner.cross.light_gray": "K'anch'etan sovter",
  "block.minecraft.banner.cross.lime": "Yoxyoxtik sovter",
  "block.minecraft.banner.cross.magenta": "Tsojtsojtik sovter",
  "block.minecraft.banner.cross.orange": "K'onk'ontik sovter",
  "block.minecraft.banner.cross.pink": "Tsojtsojtik sovter",
  "block.minecraft.banner.cross.purple": "Ik'pok'an sovter",
  "block.minecraft.banner.cross.red": "Tsajal sovter",
  "block.minecraft.banner.cross.white": "Sakil sovter",
  "block.minecraft.banner.cross.yellow": "K'anal sovter",
  "block.minecraft.banner.curly_border.black": "Ik'al tanal-eal ti'il",
  "block.minecraft.banner.curly_border.blue": "Yaxal tanal-eal ti'il",
  "block.minecraft.banner.curly_border.brown": "K'anch'etan tanal-eal ti'il",
  "block.minecraft.banner.curly_border.cyan": "Yax-elan tanal-eal ti'il",
  "block.minecraft.banner.curly_border.gray": "K'anch'etan tanal-eal ti'il",
  "block.minecraft.banner.curly_border.green": "Yaxal tanal-eal ti'il",
  "block.minecraft.banner.curly_border.light_blue": "Yaxal tanal-eal ti'il",
  "block.minecraft.banner.curly_border.light_gray": "K'anch'etan tanal-eal ti'il",
  "block.minecraft.banner.curly_border.lime": "Yoxyoxtik tanal-eal ti'il",
  "block.minecraft.banner.curly_border.magenta": "Tsojtsojtik tanal-eal ti'il",
  "block.minecraft.banner.curly_border.orange": "K'onk'ontik tanal-eal ti'il",
  "block.minecraft.banner.curly_border.pink": "Tsojtsojtik tanal-eal ti'il",
  "block.minecraft.banner.curly_border.purple": "Ik'pok'an tanal-eal ti'il",
  "block.minecraft.banner.curly_border.red": "Tsajal tanal-eal ti'il",
  "block.minecraft.banner.curly_border.white": "Sakil tanal-eal ti'il",
  "block.minecraft.banner.curly_border.yellow": "K'anal tanal-eal ti'il",
  "block.minecraft.banner.diagonal_left.black": "Ik'al bojel",
  "block.minecraft.banner.diagonal_left.blue": "Yaxal bojel",
  "block.minecraft.banner.diagonal_left.brown": "K'anch'etan bojel",
  "block.minecraft.banner.diagonal_left.cyan": "Yax-elan bojel",
  "block.minecraft.banner.diagonal_left.gray": "K'anch'etan bojel",
  "block.minecraft.banner.diagonal_left.green": "Yaxal bojel",
  "block.minecraft.banner.diagonal_left.light_blue": "Yaxal bojel",
  "block.minecraft.banner.diagonal_left.light_gray": "K'anch'etan bojel",
  "block.minecraft.banner.diagonal_left.lime": "Yoxyoxtik bojel",
  "block.minecraft.banner.diagonal_left.magenta": "Tsojtsojtik bojel",
  "block.minecraft.banner.diagonal_left.orange": "K'onk'ontik bojel",
  "block.minecraft.banner.diagonal_left.pink": "Tsojtsojtik bojel",
  "block.minecraft.banner.diagonal_left.purple": "Ik'pok'an bojel",
  "block.minecraft.banner.diagonal_left.red": "Tsajal bojel",
  "block.minecraft.banner.diagonal_left.white": "Sakil bojel",
  "block.minecraft.banner.diagonal_left.yellow": "K'anal bojel",
  "block.minecraft.banner.diagonal_right.black": "Ik'al t'oxel",
  "block.minecraft.banner.diagonal_right.blue": "Yaxal t'oxel",
  "block.minecraft.banner.diagonal_right.brown": "K'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_right.cyan": "Yax-elan t'oxel",
  "block.minecraft.banner.diagonal_right.gray": "K'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_right.green": "Yaxal t'oxel",
  "block.minecraft.banner.diagonal_right.light_blue": "Yaxal t'oxel",
  "block.minecraft.banner.diagonal_right.light_gray": "K'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_right.lime": "Yoxyoxtik t'oxel",
  "block.minecraft.banner.diagonal_right.magenta": "Tsojtsojtik t'oxel",
  "block.minecraft.banner.diagonal_right.orange": "K'onk'ontik t'oxel",
  "block.minecraft.banner.diagonal_right.pink": "Tsojtsojtik t'oxel",
  "block.minecraft.banner.diagonal_right.purple": "Ik'pok'an t'oxel",
  "block.minecraft.banner.diagonal_right.red": "Tsajal t'oxel",
  "block.minecraft.banner.diagonal_right.white": "Sakil t'oxel",
  "block.minecraft.banner.diagonal_right.yellow": "K'anal t'oxel",
  "block.minecraft.banner.diagonal_up_left.black": "Valk'unbil ik'al t'oxel",
  "block.minecraft.banner.diagonal_up_left.blue": "Valk'unbil yaxal t'oxel",
  "block.minecraft.banner.diagonal_up_left.brown": "Valk'unbil k'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_up_left.cyan": "Valk'unbil yax-elan t'oxel",
  "block.minecraft.banner.diagonal_up_left.gray": "Valk'unbil k'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_up_left.green": "Valk'unbil yaxal t'oxel",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Valk'unbil yaxal t'oxel",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Valk'unbil k'anch'etan t'oxel",
  "block.minecraft.banner.diagonal_up_left.lime": "Valk'unbil yoxyoxtik t'oxel",
  "block.minecraft.banner.diagonal_up_left.magenta": "Valk'unbil tsojtsojtik t'oxel",
  "block.minecraft.banner.diagonal_up_left.orange": "Valk'unbil k'onk'ontik t'oxel",
  "block.minecraft.banner.diagonal_up_left.pink": "Valk'unbil tsojtsojtik t'oxel",
  "block.minecraft.banner.diagonal_up_left.purple": "Valk'unbil ik'pok'an t'oxel",
  "block.minecraft.banner.diagonal_up_left.red": "Valk'unbil tsajal t'oxel",
  "block.minecraft.banner.diagonal_up_left.white": "Valk'unbil sakil t'oxel",
  "block.minecraft.banner.diagonal_up_left.yellow": "Valk'unbil k'anal t'oxel",
  "block.minecraft.banner.diagonal_up_right.black": "Valk'unbil ik'al bojel",
  "block.minecraft.banner.diagonal_up_right.blue": "Valk'unbil yaxal bojel",
  "block.minecraft.banner.diagonal_up_right.brown": "Valk'unbil k'anch'etan bojel",
  "block.minecraft.banner.diagonal_up_right.cyan": "Valk'unbil yax-elan bojel",
  "block.minecraft.banner.diagonal_up_right.gray": "Valk'unbil k'anch'etan bojel",
  "block.minecraft.banner.diagonal_up_right.green": "Valk'unbil yaxal bojel",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Valk'unbil yaxal bojel",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Valk'unbil k'anch'etan bojel",
  "block.minecraft.banner.diagonal_up_right.lime": "Valk'unbil yoxyoxtik bojel",
  "block.minecraft.banner.diagonal_up_right.magenta": "Valk'unbil tsojtsojtik bojel",
  "block.minecraft.banner.diagonal_up_right.orange": "Valk'unbil k'onk'ontik bojel",
  "block.minecraft.banner.diagonal_up_right.pink": "Valk'unbil tsojtsojtik bojel",
  "block.minecraft.banner.diagonal_up_right.purple": "Valk'unbil ik'pok'an bojel",
  "block.minecraft.banner.diagonal_up_right.red": "Valk'unbil tsajal bojel",
  "block.minecraft.banner.diagonal_up_right.white": "Valk'unbil sakil bojel",
  "block.minecraft.banner.diagonal_up_right.yellow": "Valk'unbil k'anal bojel",
  "block.minecraft.banner.flow.black": "Ik'al espiral",
  "block.minecraft.banner.flow.blue": "Yaxal espiral",
  "block.minecraft.banner.flow.brown": "K'anch'etan espiral",
  "block.minecraft.banner.flow.cyan": "Yax-elan espiral",
  "block.minecraft.banner.flow.gray": "K'anch'etan espiral",
  "block.minecraft.banner.flow.green": "Yaxal espiral",
  "block.minecraft.banner.flow.light_blue": "Yaxal espiral",
  "block.minecraft.banner.flow.light_gray": "K'anch'etan espiral",
  "block.minecraft.banner.flow.lime": "Yoxyoxtik espiral",
  "block.minecraft.banner.flow.magenta": "Tsojtsojtik espiral",
  "block.minecraft.banner.flow.orange": "K'onk'ontik espiral",
  "block.minecraft.banner.flow.pink": "Tsojtsojtik espiral",
  "block.minecraft.banner.flow.purple": "Ik'pok'an espiral",
  "block.minecraft.banner.flow.red": "Tsajal espiral",
  "block.minecraft.banner.flow.white": "Sakil espiral",
  "block.minecraft.banner.flow.yellow": "K'anal espiral",
  "block.minecraft.banner.flower.black": "Ik'al nichim",
  "block.minecraft.banner.flower.blue": "Yaxal nichim",
  "block.minecraft.banner.flower.brown": "K'anch'etan nichim",
  "block.minecraft.banner.flower.cyan": "Yax-elan nichim",
  "block.minecraft.banner.flower.gray": "K'anch'etan nichim",
  "block.minecraft.banner.flower.green": "Yaxal nichim",
  "block.minecraft.banner.flower.light_blue": "Yaxal nichim",
  "block.minecraft.banner.flower.light_gray": "K'anch'etan nichim",
  "block.minecraft.banner.flower.lime": "Yoxyoxtik nichim",
  "block.minecraft.banner.flower.magenta": "Tsojtsojtik nichim",
  "block.minecraft.banner.flower.orange": "K'onk'ontik nichim",
  "block.minecraft.banner.flower.pink": "Tsojtsojtik nichim",
  "block.minecraft.banner.flower.purple": "Ik'pok'an nichim",
  "block.minecraft.banner.flower.red": "Tsajal nichim",
  "block.minecraft.banner.flower.white": "Sakil nichim",
  "block.minecraft.banner.flower.yellow": "K'anal nichim",
  "block.minecraft.banner.globe.black": "Ik'al balumil",
  "block.minecraft.banner.globe.blue": "Yaxal balumil",
  "block.minecraft.banner.globe.brown": "K'anch'etan balumil",
  "block.minecraft.banner.globe.cyan": "Yax-elan balumil",
  "block.minecraft.banner.globe.gray": "K'anch'etan balumil",
  "block.minecraft.banner.globe.green": "Yaxal balumil",
  "block.minecraft.banner.globe.light_blue": "Yaxal balumil",
  "block.minecraft.banner.globe.light_gray": "K'anch'etan balumil",
  "block.minecraft.banner.globe.lime": "Yoxyoxtik balumil",
  "block.minecraft.banner.globe.magenta": "Tsojtsojtik balumil",
  "block.minecraft.banner.globe.orange": "K'onk'ontik balumil",
  "block.minecraft.banner.globe.pink": "Tsojtsojtik balumil",
  "block.minecraft.banner.globe.purple": "Ik'pok'an balumil",
  "block.minecraft.banner.globe.red": "Tsajal balumil",
  "block.minecraft.banner.globe.white": "Sakil balumil",
  "block.minecraft.banner.globe.yellow": "K'anal balumil",
  "block.minecraft.banner.gradient.black": "Ik'al karatiente",
  "block.minecraft.banner.gradient.blue": "Yaxal karatiente",
  "block.minecraft.banner.gradient.brown": "K'anch'etan karatiente",
  "block.minecraft.banner.gradient.cyan": "Yax-elan karatiente",
  "block.minecraft.banner.gradient.gray": "K'anch'etan karatiente",
  "block.minecraft.banner.gradient.green": "Yaxal karatiente",
  "block.minecraft.banner.gradient.light_blue": "Yaxal karatiente",
  "block.minecraft.banner.gradient.light_gray": "K'anch'etan karatiente",
  "block.minecraft.banner.gradient.lime": "Yoxyoxtik karatiente",
  "block.minecraft.banner.gradient.magenta": "Tsojtsojtik karatiente",
  "block.minecraft.banner.gradient.orange": "K'onk'ontik karatiente",
  "block.minecraft.banner.gradient.pink": "Tsojtsojtik karatiente",
  "block.minecraft.banner.gradient.purple": "Ik'pok'an karatiente",
  "block.minecraft.banner.gradient.red": "Tsajal karatiente",
  "block.minecraft.banner.gradient.white": "Sakil karatiente",
  "block.minecraft.banner.gradient.yellow": "K'anal karatiente",
  "block.minecraft.banner.gradient_up.black": "Ik'al karatiente ta base",
  "block.minecraft.banner.gradient_up.blue": "Yaxal karatiente ta base",
  "block.minecraft.banner.gradient_up.brown": "K'anch'etan karatiente ta base",
  "block.minecraft.banner.gradient_up.cyan": "Yax-elan karatiente ta base",
  "block.minecraft.banner.gradient_up.gray": "K'anch'etan karatiente ta base",
  "block.minecraft.banner.gradient_up.green": "Yaxal karatiente ta base",
  "block.minecraft.banner.gradient_up.light_blue": "Yaxal karatiente ta base",
  "block.minecraft.banner.gradient_up.light_gray": "K'anch'etan karatiente ta base",
  "block.minecraft.banner.gradient_up.lime": "Yoxyoxtik karatiente ta base",
  "block.minecraft.banner.gradient_up.magenta": "Tsojtsojtik karatiente ta base",
  "block.minecraft.banner.gradient_up.orange": "K'onk'ontik karatiente ta base",
  "block.minecraft.banner.gradient_up.pink": "Tsojtsojtik karatiente ta base",
  "block.minecraft.banner.gradient_up.purple": "Ik'pok'an karatiente ta base",
  "block.minecraft.banner.gradient_up.red": "Tsajal karatiente ta base",
  "block.minecraft.banner.gradient_up.white": "Sakil karatiente ta base",
  "block.minecraft.banner.gradient_up.yellow": "K'anal karatiente ta base",
  "block.minecraft.banner.guster.black": "Ik'al sutub-ik'",
  "block.minecraft.banner.guster.blue": "Yaxal sutub-ik'",
  "block.minecraft.banner.guster.brown": "K'anch'etan sutub-ik'",
  "block.minecraft.banner.guster.cyan": "Yax-elan sutub-ik'",
  "block.minecraft.banner.guster.gray": "K'anch'etan sutub-ik'",
  "block.minecraft.banner.guster.green": "Yaxal sutub-ik'",
  "block.minecraft.banner.guster.light_blue": "Yaxal sutub-ik'",
  "block.minecraft.banner.guster.light_gray": "K'anch'etan sutub-ik'",
  "block.minecraft.banner.guster.lime": "Yoxyoxtik sutub-ik'",
  "block.minecraft.banner.guster.magenta": "Tsojtsojtik sutub-ik'",
  "block.minecraft.banner.guster.orange": "K'onk'ontik sutub-ik'",
  "block.minecraft.banner.guster.pink": "Tsojtsojtik sutub-ik'",
  "block.minecraft.banner.guster.purple": "Ik'pok'an sutub-ik'",
  "block.minecraft.banner.guster.red": "Tsajal sutub-ik'",
  "block.minecraft.banner.guster.white": "Sakil sutub-ik'",
  "block.minecraft.banner.guster.yellow": "K'anal sutub-ik'",
  "block.minecraft.banner.half_horizontal.black": "Ik'al setel",
  "block.minecraft.banner.half_horizontal.blue": "Yaxal setel",
  "block.minecraft.banner.half_horizontal.brown": "K'anch'etan setel",
  "block.minecraft.banner.half_horizontal.cyan": "Yax-elan setel",
  "block.minecraft.banner.half_horizontal.gray": "K'anch'etan setel",
  "block.minecraft.banner.half_horizontal.green": "Yaxal setel",
  "block.minecraft.banner.half_horizontal.light_blue": "Yaxal setel",
  "block.minecraft.banner.half_horizontal.light_gray": "K'anch'etan setel",
  "block.minecraft.banner.half_horizontal.lime": "Yoxyoxtik setel",
  "block.minecraft.banner.half_horizontal.magenta": "Tsojtsojtik setel",
  "block.minecraft.banner.half_horizontal.orange": "K'onk'ontik setel",
  "block.minecraft.banner.half_horizontal.pink": "Tsojtsojtik setel",
  "block.minecraft.banner.half_horizontal.purple": "Ik'pok'an setel",
  "block.minecraft.banner.half_horizontal.red": "Tsajal setel",
  "block.minecraft.banner.half_horizontal.white": "Sakil setel",
  "block.minecraft.banner.half_horizontal.yellow": "K'anal setel",
  "block.minecraft.banner.half_horizontal_bottom.black": "Valk'unbil ik'al setel",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Valk'unbil yaxal setel",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Valk'unbil k'anch'etan setel",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Valk'unbil yax-elan setel",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Valk'unbil k'anch'etan setel",
  "block.minecraft.banner.half_horizontal_bottom.green": "Valk'unbil yaxal setel",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Valk'unbil yaxal setel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Valk'unbil k'anch'etan setel",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Valk'unbil yoxyoxtik setel",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Valk'unbil tsojtsojtik setel",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Valk'unbil k'onk'ontik setel",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Valk'unbil tsojtsojtik setel",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Valk'unbil ik'pok'an setel",
  "block.minecraft.banner.half_horizontal_bottom.red": "Valk'unbil tsajal setel",
  "block.minecraft.banner.half_horizontal_bottom.white": "Valk'unbil sakil setel",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Valk'unbil k'anal setel",
  "block.minecraft.banner.half_vertical.black": "Ik'al javel",
  "block.minecraft.banner.half_vertical.blue": "Yaxal javel",
  "block.minecraft.banner.half_vertical.brown": "K'anch'etan javel",
  "block.minecraft.banner.half_vertical.cyan": "Yax-elan javel",
  "block.minecraft.banner.half_vertical.gray": "K'anch'etan javel",
  "block.minecraft.banner.half_vertical.green": "Yaxal javel",
  "block.minecraft.banner.half_vertical.light_blue": "Yaxal javel",
  "block.minecraft.banner.half_vertical.light_gray": "K'anch'etan javel",
  "block.minecraft.banner.half_vertical.lime": "Yoxyoxtik javel",
  "block.minecraft.banner.half_vertical.magenta": "Tsojtsojtik javel",
  "block.minecraft.banner.half_vertical.orange": "K'onk'ontik javel",
  "block.minecraft.banner.half_vertical.pink": "Tsojtsojtik javel",
  "block.minecraft.banner.half_vertical.purple": "Ik'pok'an javel",
  "block.minecraft.banner.half_vertical.red": "Ik'pok'an javel",
  "block.minecraft.banner.half_vertical.white": "Sakil javel",
  "block.minecraft.banner.half_vertical.yellow": "K'anal javel",
  "block.minecraft.banner.half_vertical_right.black": "Valk'unbil ik'al javel",
  "block.minecraft.banner.half_vertical_right.blue": "Valk'unbil yaxal javel",
  "block.minecraft.banner.half_vertical_right.brown": "Valk'unbil k'anch'etan javel",
  "block.minecraft.banner.half_vertical_right.cyan": "Valk'unbil yax-elan javel",
  "block.minecraft.banner.half_vertical_right.gray": "Valk'unbil k'anch'etan javel",
  "block.minecraft.banner.half_vertical_right.green": "Valk'unbil yaxal javel",
  "block.minecraft.banner.half_vertical_right.light_blue": "Valk'unbil yaxal javel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Valk'unbil k'anch'etan javel",
  "block.minecraft.banner.half_vertical_right.lime": "Valk'unbil yoxyoxtik javel",
  "block.minecraft.banner.half_vertical_right.magenta": "Valk'unbil tsojtsojtik javel",
  "block.minecraft.banner.half_vertical_right.orange": "Valk'unbil k'onk'ontik javel",
  "block.minecraft.banner.half_vertical_right.pink": "Valk'unbil tsojtsojtik javel",
  "block.minecraft.banner.half_vertical_right.purple": "Valk'unbil ik'pok'an javel",
  "block.minecraft.banner.half_vertical_right.red": "Valk'unbil tsajal javel",
  "block.minecraft.banner.half_vertical_right.white": "Valk'unbil sakil javel",
  "block.minecraft.banner.half_vertical_right.yellow": "Valk'unbil k'anal javel",
  "block.minecraft.banner.mojang.black": "Ik'al k'usi",
  "block.minecraft.banner.mojang.blue": "Yaxal k'usi",
  "block.minecraft.banner.mojang.brown": "K'anch'etan k'usi",
  "block.minecraft.banner.mojang.cyan": "Yax-elan k'usi",
  "block.minecraft.banner.mojang.gray": "K'anch'etan k'usi",
  "block.minecraft.banner.mojang.green": "Yaxal k'usi",
  "block.minecraft.banner.mojang.light_blue": "Yaxal k'usi",
  "block.minecraft.banner.mojang.light_gray": "K'anch'etan k'usi",
  "block.minecraft.banner.mojang.lime": "Yoxyoxtik k'usi",
  "block.minecraft.banner.mojang.magenta": "Tsojtsojtik k'usi",
  "block.minecraft.banner.mojang.orange": "K'onk'ontik k'usi",
  "block.minecraft.banner.mojang.pink": "Tsojtsojtik k'usi",
  "block.minecraft.banner.mojang.purple": "Ik'pok'an k'usi",
  "block.minecraft.banner.mojang.red": "Tsajal k'usi",
  "block.minecraft.banner.mojang.white": "Sakil k'usi",
  "block.minecraft.banner.mojang.yellow": "K'anal k'usi",
  "block.minecraft.banner.piglin.black": "Ik'al eil",
  "block.minecraft.banner.piglin.blue": "Yaxal eil",
  "block.minecraft.banner.piglin.brown": "K'anch'etan eil",
  "block.minecraft.banner.piglin.cyan": "Yax-elan eil",
  "block.minecraft.banner.piglin.gray": "K'anch'etan eil",
  "block.minecraft.banner.piglin.green": "Yaxal eil",
  "block.minecraft.banner.piglin.light_blue": "Yaxal eil",
  "block.minecraft.banner.piglin.light_gray": "K'anch'etan eil",
  "block.minecraft.banner.piglin.lime": "Yoxyoxtik eil",
  "block.minecraft.banner.piglin.magenta": "Tsojtsojtik eil",
  "block.minecraft.banner.piglin.orange": "K'onk'ontik eil",
  "block.minecraft.banner.piglin.pink": "Tsojtsojtik eil",
  "block.minecraft.banner.piglin.purple": "Ik'pok'an eil",
  "block.minecraft.banner.piglin.red": "Tsajal eil",
  "block.minecraft.banner.piglin.white": "Sakil eil",
  "block.minecraft.banner.piglin.yellow": "K'anal eil",
  "block.minecraft.banner.rhombus.black": "Ik'al losanje",
  "block.minecraft.banner.rhombus.blue": "Yaxal losanje",
  "block.minecraft.banner.rhombus.brown": "K'anch'etan losanje",
  "block.minecraft.banner.rhombus.cyan": "Yax-elan losanje",
  "block.minecraft.banner.rhombus.gray": "K'anch'etan losanje",
  "block.minecraft.banner.rhombus.green": "Yaxal losanje",
  "block.minecraft.banner.rhombus.light_blue": "Yaxal losanje",
  "block.minecraft.banner.rhombus.light_gray": "K'anch'etan losanje",
  "block.minecraft.banner.rhombus.lime": "Yoxyoxtik losanje",
  "block.minecraft.banner.rhombus.magenta": "Tsojtsojtik losanje",
  "block.minecraft.banner.rhombus.orange": "K'onk'ontik losanje",
  "block.minecraft.banner.rhombus.pink": "Tsojtsojtik losanje",
  "block.minecraft.banner.rhombus.purple": "Ik'pok'an losanje",
  "block.minecraft.banner.rhombus.red": "Tsajal losanje",
  "block.minecraft.banner.rhombus.white": "Sakil losanje",
  "block.minecraft.banner.rhombus.yellow": "K'anal losanje",
  "block.minecraft.banner.skull.black": "Ik'al bakil jolil",
  "block.minecraft.banner.skull.blue": "Yaxal bakil jolil",
  "block.minecraft.banner.skull.brown": "K'anch'etan bakil jolil",
  "block.minecraft.banner.skull.cyan": "Yax-elan bakil jolil",
  "block.minecraft.banner.skull.gray": "K'anch'etan bakil jolil",
  "block.minecraft.banner.skull.green": "Yaxal bakil jolil",
  "block.minecraft.banner.skull.light_blue": "Yaxal bakil jolil",
  "block.minecraft.banner.skull.light_gray": "K'anch'etan bakil jolil",
  "block.minecraft.banner.skull.lime": "Yoxyoxtik bakil jolil",
  "block.minecraft.banner.skull.magenta": "Tsojtsojtik bakil jolil",
  "block.minecraft.banner.skull.orange": "K'onk'ontik bakil jolil",
  "block.minecraft.banner.skull.pink": "Tsojtsojtik bakil jolil",
  "block.minecraft.banner.skull.purple": "Ik'pok'an bakil jolil",
  "block.minecraft.banner.skull.red": "Tsajal bakil jolil",
  "block.minecraft.banner.skull.white": "Sakil bakil jolil",
  "block.minecraft.banner.skull.yellow": "K'anal bakil jolil",
  "block.minecraft.banner.small_stripes.black": "Ik'al namte'al",
  "block.minecraft.banner.small_stripes.blue": "Yaxal namte'al",
  "block.minecraft.banner.small_stripes.brown": "K'anch'etan namte'al",
  "block.minecraft.banner.small_stripes.cyan": "Yax-elan namte'al",
  "block.minecraft.banner.small_stripes.gray": "K'anch'etan namte'al",
  "block.minecraft.banner.small_stripes.green": "Yaxal namte'al",
  "block.minecraft.banner.small_stripes.light_blue": "Yaxal namte'al",
  "block.minecraft.banner.small_stripes.light_gray": "K'anch'etan namte'al",
  "block.minecraft.banner.small_stripes.lime": "Yoxyoxtik namte'al",
  "block.minecraft.banner.small_stripes.magenta": "Tsojtsojtik namte'al",
  "block.minecraft.banner.small_stripes.orange": "K'onk'ontik namte'al",
  "block.minecraft.banner.small_stripes.pink": "Tsojtsojtik namte'al",
  "block.minecraft.banner.small_stripes.purple": "Ik'pok'an namte'al",
  "block.minecraft.banner.small_stripes.red": "Tsajal namte'al",
  "block.minecraft.banner.small_stripes.white": "Sakil namte'al",
  "block.minecraft.banner.small_stripes.yellow": "K'anal namte'al",
  "block.minecraft.banner.square_bottom_left.black": "Ik'al bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.blue": "Yaxal bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.brown": "K'anch'etan bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.cyan": "Yax-elan bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.gray": "K'anch'etan bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.green": "Yaxal bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.light_blue": "Yaxal bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.light_gray": "K'anch'etan bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.lime": "Yoxyoxtik bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.magenta": "Tsojtsojtik bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.orange": "K'onk'ontik bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.pink": "Tsojtsojtik bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.purple": "Ik'pok'an bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.red": "Tsajal bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.white": "Sakil bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_left.yellow": "K'anal bats'i kanton ta base",
  "block.minecraft.banner.square_bottom_right.black": "Ik'al ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.blue": "Yaxal ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.brown": "K'anch'etan ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.cyan": "Yax-elan ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.gray": "K'anch'etan ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.green": "Yaxal ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.light_blue": "Yaxal ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.light_gray": "K'anch'etan ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.lime": "Yoxyoxtik ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.magenta": "Tsojtsojtik ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.orange": "K'onk'ontik ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.pink": "Tsojtsojtik ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.purple": "Ik'pok'an ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.red": "Tsajal ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.white": "Sakil ts'et kanton ta base",
  "block.minecraft.banner.square_bottom_right.yellow": "K'anal ts'et kanton ta base",
  "block.minecraft.banner.square_top_left.black": "Ik'al bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.blue": "Yaxal bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.brown": "K'anch'etan bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.cyan": "Yax-elan bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.gray": "K'anch'etan bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.green": "Yaxal bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.light_blue": "Yaxal bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.light_gray": "K'anch'etan bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.lime": "Yoxyoxtik bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.magenta": "Tsojtsojtik bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.orange": "K'onk'ontik bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.pink": "Tsojtsojtik bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.purple": "Ik'pok'an bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.red": "Tsajal bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.white": "Sakil bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_left.yellow": "K'anal bats'i kanton ta jolil",
  "block.minecraft.banner.square_top_right.black": "Ik'al ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.blue": "Yaxal ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.brown": "K'anch'etan ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.cyan": "Yax-elan ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.gray": "K'anch'etan ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.green": "Yaxal ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.light_blue": "Yaxal ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.light_gray": "K'anch'etan ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.lime": "Yoxyoxtik ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.magenta": "Tsojtsojtik ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.orange": "K'onk'ontik ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.pink": "Tsojtsojtik ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.purple": "Ik'pok'an ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.red": "Tsajal ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.white": "Sakil ts'et kanton ta jolil",
  "block.minecraft.banner.square_top_right.yellow": "K'anal ts'et kanton ta jolil",
  "block.minecraft.banner.straight_cross.black": "Ik'al kurus",
  "block.minecraft.banner.straight_cross.blue": "Yaxal kurus",
  "block.minecraft.banner.straight_cross.brown": "K'anch'etan kurus",
  "block.minecraft.banner.straight_cross.cyan": "Yax-elan kurus",
  "block.minecraft.banner.straight_cross.gray": "K'anch'etan kurus",
  "block.minecraft.banner.straight_cross.green": "Yaxal kurus",
  "block.minecraft.banner.straight_cross.light_blue": "Yaxal kurus",
  "block.minecraft.banner.straight_cross.light_gray": "K'anch'etan kurus",
  "block.minecraft.banner.straight_cross.lime": "Yoxyoxtik kurus",
  "block.minecraft.banner.straight_cross.magenta": "Tsojtsojtik kurus",
  "block.minecraft.banner.straight_cross.orange": "K'onk'ontik kurus",
  "block.minecraft.banner.straight_cross.pink": "Tsojtsojtik kurus",
  "block.minecraft.banner.straight_cross.purple": "Ik'pok'an kurus",
  "block.minecraft.banner.straight_cross.red": "Tsajal kurus",
  "block.minecraft.banner.straight_cross.white": "Sakil kurus",
  "block.minecraft.banner.straight_cross.yellow": "K'anal kurus",
  "block.minecraft.banner.stripe_bottom.black": "Ik'al base",
  "block.minecraft.banner.stripe_bottom.blue": "Yaxal base",
  "block.minecraft.banner.stripe_bottom.brown": "K'anch'etan base",
  "block.minecraft.banner.stripe_bottom.cyan": "Yax-elan base",
  "block.minecraft.banner.stripe_bottom.gray": "K'anch'etan base",
  "block.minecraft.banner.stripe_bottom.green": "Yaxal base",
  "block.minecraft.banner.stripe_bottom.light_blue": "Yaxal base",
  "block.minecraft.banner.stripe_bottom.light_gray": "K'anch'etan base",
  "block.minecraft.banner.stripe_bottom.lime": "Yoxyoxtik base",
  "block.minecraft.banner.stripe_bottom.magenta": "Tsojtsojtik base",
  "block.minecraft.banner.stripe_bottom.orange": "K'onk'ontik base",
  "block.minecraft.banner.stripe_bottom.pink": "Tsojtsojtik base",
  "block.minecraft.banner.stripe_bottom.purple": "Ik'pok'an base",
  "block.minecraft.banner.stripe_bottom.red": "Tsajal base",
  "block.minecraft.banner.stripe_bottom.white": "Sakil base",
  "block.minecraft.banner.stripe_bottom.yellow": "K'anal base",
  "block.minecraft.banner.stripe_center.black": "Ik'al te'",
  "block.minecraft.banner.stripe_center.blue": "Yaxal te'",
  "block.minecraft.banner.stripe_center.brown": "K'anch'etan te'",
  "block.minecraft.banner.stripe_center.cyan": "Yax-elan te'",
  "block.minecraft.banner.stripe_center.gray": "K'anch'etan te'",
  "block.minecraft.banner.stripe_center.green": "Yaxal te'",
  "block.minecraft.banner.stripe_center.light_blue": "Yaxal te'",
  "block.minecraft.banner.stripe_center.light_gray": "K'anch'etan te'",
  "block.minecraft.banner.stripe_center.lime": "Yoxyoxtik te'",
  "block.minecraft.banner.stripe_center.magenta": "Tsojtsojtik te'",
  "block.minecraft.banner.stripe_center.orange": "K'onk'ontik te'",
  "block.minecraft.banner.stripe_center.pink": "Tsojtsojtik te'",
  "block.minecraft.banner.stripe_center.purple": "Ik'pok'an te'",
  "block.minecraft.banner.stripe_center.red": "Tsajal te'",
  "block.minecraft.banner.stripe_center.white": "Sakil te'",
  "block.minecraft.banner.stripe_center.yellow": "K'anal te'",
  "block.minecraft.banner.stripe_downleft.black": "Ik'al te'eltak'in",
  "block.minecraft.banner.stripe_downleft.blue": "Yaxal te'eltak'in",
  "block.minecraft.banner.stripe_downleft.brown": "K'anch'etan te'eltak'in",
  "block.minecraft.banner.stripe_downleft.cyan": "Yax-elan te'eltak'in",
  "block.minecraft.banner.stripe_downleft.gray": "K'anch'etan te'eltak'in",
  "block.minecraft.banner.stripe_downleft.green": "Yaxal te'eltak'in",
  "block.minecraft.banner.stripe_downleft.light_blue": "Yaxal te'eltak'in",
  "block.minecraft.banner.stripe_downleft.light_gray": "K'anch'etan te'eltak'in",
  "block.minecraft.banner.stripe_downleft.lime": "Yoxyoxtik te'eltak'in",
  "block.minecraft.banner.stripe_downleft.magenta": "Tsojtsojtik te'eltak'in",
  "block.minecraft.banner.stripe_downleft.orange": "K'onk'ontik te'eltak'in",
  "block.minecraft.banner.stripe_downleft.pink": "Tsojtsojtik te'eltak'in",
  "block.minecraft.banner.stripe_downleft.purple": "Ik'pok'an te'eltak'in",
  "block.minecraft.banner.stripe_downleft.red": "Tsajal te'eltak'in",
  "block.minecraft.banner.stripe_downleft.white": "Sakil te'eltak'in",
  "block.minecraft.banner.stripe_downleft.yellow": "K'anal te'eltak'in",
  "block.minecraft.banner.stripe_downright.black": "Ik'al tabpat",
  "block.minecraft.banner.stripe_downright.blue": "Yaxal tabpat",
  "block.minecraft.banner.stripe_downright.brown": "K'anch'etan tabpat",
  "block.minecraft.banner.stripe_downright.cyan": "Yax-elan tabpat",
  "block.minecraft.banner.stripe_downright.gray": "K'anch'etan tabpat",
  "block.minecraft.banner.stripe_downright.green": "Yaxal tabpat",
  "block.minecraft.banner.stripe_downright.light_blue": "Yaxal tabpat",
  "block.minecraft.banner.stripe_downright.light_gray": "K'anch'etan tabpat",
  "block.minecraft.banner.stripe_downright.lime": "Yoxyoxtik tabpat",
  "block.minecraft.banner.stripe_downright.magenta": "Tsojtsojtik tabpat",
  "block.minecraft.banner.stripe_downright.orange": "K'onk'ontik tabpat",
  "block.minecraft.banner.stripe_downright.pink": "Tsojtsojtik tabpat",
  "block.minecraft.banner.stripe_downright.purple": "Ik'pok'an tabpat",
  "block.minecraft.banner.stripe_downright.red": "Tsajal tabpat",
  "block.minecraft.banner.stripe_downright.white": "Sakil tabpat",
  "block.minecraft.banner.stripe_downright.yellow": "K'anal tabpat",
  "block.minecraft.banner.stripe_left.black": "Ik'al te' ta bats'i",
  "block.minecraft.banner.stripe_left.blue": "Yaxal te' ta bats'i",
  "block.minecraft.banner.stripe_left.brown": "K'anch'etan te' ta bats'i",
  "block.minecraft.banner.stripe_left.cyan": "Yax-elan te' ta bats'i",
  "block.minecraft.banner.stripe_left.gray": "K'anch'etan te' ta bats'i",
  "block.minecraft.banner.stripe_left.green": "Yaxal te' ta bats'i",
  "block.minecraft.banner.stripe_left.light_blue": "Yaxal te' ta bats'i",
  "block.minecraft.banner.stripe_left.light_gray": "K'anch'etan te' ta bats'i",
  "block.minecraft.banner.stripe_left.lime": "Yoxyoxtik te' ta bats'i",
  "block.minecraft.banner.stripe_left.magenta": "Tsojtsojtik te' ta bats'i",
  "block.minecraft.banner.stripe_left.orange": "K'onk'ontik te' ta bats'i",
  "block.minecraft.banner.stripe_left.pink": "Tsojtsojtik te' ta bats'i",
  "block.minecraft.banner.stripe_left.purple": "Ik'pok'an te' ta bats'i",
  "block.minecraft.banner.stripe_left.red": "Tsajal te' ta bats'i",
  "block.minecraft.banner.stripe_left.white": "Sakil te' ta bats'i",
  "block.minecraft.banner.stripe_left.yellow": "K'anal te' ta bats'i",
  "block.minecraft.banner.stripe_middle.black": "Ik'al xinchail",
  "block.minecraft.banner.stripe_middle.blue": "Yaxal xinchail",
  "block.minecraft.banner.stripe_middle.brown": "K'anch'etan xinchail",
  "block.minecraft.banner.stripe_middle.cyan": "Yax-elan xinchail",
  "block.minecraft.banner.stripe_middle.gray": "K'anch'etan xinchail",
  "block.minecraft.banner.stripe_middle.green": "Yaxal xinchail",
  "block.minecraft.banner.stripe_middle.light_blue": "Yaxal xinchail",
  "block.minecraft.banner.stripe_middle.light_gray": "K'anch'etan xinchail",
  "block.minecraft.banner.stripe_middle.lime": "Yoxyoxtik xinchail",
  "block.minecraft.banner.stripe_middle.magenta": "Tsojtsojtik xinchail",
  "block.minecraft.banner.stripe_middle.orange": "K'onk'ontik xinchail",
  "block.minecraft.banner.stripe_middle.pink": "Tsojtsojtik xinchail",
  "block.minecraft.banner.stripe_middle.purple": "Ik'pok'an xinchail",
  "block.minecraft.banner.stripe_middle.red": "Tsajal xinchail",
  "block.minecraft.banner.stripe_middle.white": "Sakil xinchail",
  "block.minecraft.banner.stripe_middle.yellow": "K'anal xinchail",
  "block.minecraft.banner.stripe_right.black": "Ik'al te' ta ts'et",
  "block.minecraft.banner.stripe_right.blue": "Yaxal te' ta ts'et",
  "block.minecraft.banner.stripe_right.brown": "K'anch'etan te' ta ts'et",
  "block.minecraft.banner.stripe_right.cyan": "Yax-elan te' ta ts'et",
  "block.minecraft.banner.stripe_right.gray": "K'anch'etan te' ta ts'et",
  "block.minecraft.banner.stripe_right.green": "Yaxal te' ta ts'et",
  "block.minecraft.banner.stripe_right.light_blue": "Yaxal te' ta ts'et",
  "block.minecraft.banner.stripe_right.light_gray": "K'anch'etan te' ta ts'et",
  "block.minecraft.banner.stripe_right.lime": "Yoxyoxtik te' ta ts'et",
  "block.minecraft.banner.stripe_right.magenta": "Tsojtsojtik te' ta ts'et",
  "block.minecraft.banner.stripe_right.orange": "K'onk'ontik te' ta ts'et",
  "block.minecraft.banner.stripe_right.pink": "Tsojtsojtik te' ta ts'et",
  "block.minecraft.banner.stripe_right.purple": "Ik'pok'an te' ta ts'et",
  "block.minecraft.banner.stripe_right.red": "Tsajal te' ta ts'et",
  "block.minecraft.banner.stripe_right.white": "Sakil te' ta ts'et",
  "block.minecraft.banner.stripe_right.yellow": "K'anal te' ta ts'et",
  "block.minecraft.banner.stripe_top.black": "Ik'al jolil",
  "block.minecraft.banner.stripe_top.blue": "Yaxal jolil",
  "block.minecraft.banner.stripe_top.brown": "K'anch'etan jolil",
  "block.minecraft.banner.stripe_top.cyan": "Yax-elan jolil",
  "block.minecraft.banner.stripe_top.gray": "K'anch'etan jolil",
  "block.minecraft.banner.stripe_top.green": "Yaxal jolil",
  "block.minecraft.banner.stripe_top.light_blue": "Yaxal jolil",
  "block.minecraft.banner.stripe_top.light_gray": "K'anch'etan jolil",
  "block.minecraft.banner.stripe_top.lime": "Yoxyoxtik jolil",
  "block.minecraft.banner.stripe_top.magenta": "Tsojtsojtik jolil",
  "block.minecraft.banner.stripe_top.orange": "K'onk'ontik jolil",
  "block.minecraft.banner.stripe_top.pink": "Tsojtsojtik jolil",
  "block.minecraft.banner.stripe_top.purple": "Ik'pok'an jolil",
  "block.minecraft.banner.stripe_top.red": "Tsajal jolil",
  "block.minecraft.banner.stripe_top.white": "Sakil jolil",
  "block.minecraft.banner.stripe_top.yellow": "K'anal jolil",
  "block.minecraft.banner.triangle_bottom.black": "Ik'al chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Yaxal chevron",
  "block.minecraft.banner.triangle_bottom.brown": "K'anch'etan chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Yax-elan chevron",
  "block.minecraft.banner.triangle_bottom.gray": "K'anch'etan chevron",
  "block.minecraft.banner.triangle_bottom.green": "Yaxal chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Yaxal chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "K'anch'etan chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Yoxyoxtik chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Tsojtsojtik chevron",
  "block.minecraft.banner.triangle_bottom.orange": "K'onk'ontik chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Tsojtsojtik chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Ik'pok'an chevron",
  "block.minecraft.banner.triangle_bottom.red": "Tsajal chevron",
  "block.minecraft.banner.triangle_bottom.white": "Sakil chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "K'anal chevron",
  "block.minecraft.banner.triangle_top.black": "Valk'unbil ik'al chevron",
  "block.minecraft.banner.triangle_top.blue": "Valk'unbil yaxal chevron",
  "block.minecraft.banner.triangle_top.brown": "Valk'unbil k'anch'etan chevron",
  "block.minecraft.banner.triangle_top.cyan": "Valk'unbil yax-elan chevron",
  "block.minecraft.banner.triangle_top.gray": "Valk'unbil k'anch'etan chevron",
  "block.minecraft.banner.triangle_top.green": "Valk'unbil yaxal chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Valk'unbil yaxal chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Valk'unbil k'anch'etan chevron",
  "block.minecraft.banner.triangle_top.lime": "Valk'unbil yoxyoxtik chevron",
  "block.minecraft.banner.triangle_top.magenta": "Valk'unbil tsojtsojtik chevron",
  "block.minecraft.banner.triangle_top.orange": "Valk'unbil k'onk'ontik chevron",
  "block.minecraft.banner.triangle_top.pink": "Valk'unbil tsojtsojtik chevron",
  "block.minecraft.banner.triangle_top.purple": "Valk'unbil ik'pok'an chevron",
  "block.minecraft.banner.triangle_top.red": "Valk'unbil tsajal chevron",
  "block.minecraft.banner.triangle_top.white": "Valk'unbil sakil chevron",
  "block.minecraft.banner.triangle_top.yellow": "Valk'unbil k'anal chevron",
  "block.minecraft.banner.triangles_bottom.black": "Ik'al tanal-eal base",
  "block.minecraft.banner.triangles_bottom.blue": "Yaxal tanal-eal base",
  "block.minecraft.banner.triangles_bottom.brown": "K'anch'etan tanal-eal base",
  "block.minecraft.banner.triangles_bottom.cyan": "Yax-elan tanal-eal base",
  "block.minecraft.banner.triangles_bottom.gray": "K'anch'etan tanal-eal base",
  "block.minecraft.banner.triangles_bottom.green": "Yaxal tanal-eal base",
  "block.minecraft.banner.triangles_bottom.light_blue": "Yaxal tanal-eal base",
  "block.minecraft.banner.triangles_bottom.light_gray": "K'anch'etan tanal-eal base",
  "block.minecraft.banner.triangles_bottom.lime": "Yoxyoxtik tanal-eal base",
  "block.minecraft.banner.triangles_bottom.magenta": "Tsojtsojtik tanal-eal base",
  "block.minecraft.banner.triangles_bottom.orange": "K'onk'ontik tanal-eal base",
  "block.minecraft.banner.triangles_bottom.pink": "Tsojtsojtik tanal-eal base",
  "block.minecraft.banner.triangles_bottom.purple": "Ik'pok'an tanal-eal base",
  "block.minecraft.banner.triangles_bottom.red": "Tsajal tanal-eal base",
  "block.minecraft.banner.triangles_bottom.white": "Sakil tanal-eal base",
  "block.minecraft.banner.triangles_bottom.yellow": "K'anal tanal-eal base",
  "block.minecraft.banner.triangles_top.black": "Ik'al tanal-eal jolil",
  "block.minecraft.banner.triangles_top.blue": "Yaxal tanal-eal jolil",
  "block.minecraft.banner.triangles_top.brown": "K'anch'etan tanal-eal jolil",
  "block.minecraft.banner.triangles_top.cyan": "Yax-elan tanal-eal jolil",
  "block.minecraft.banner.triangles_top.gray": "K'anch'etan tanal-eal jolil",
  "block.minecraft.banner.triangles_top.green": "Yaxal tanal-eal jolil",
  "block.minecraft.banner.triangles_top.light_blue": "Yaxal tanal-eal jolil",
  "block.minecraft.banner.triangles_top.light_gray": "K'anch'etan tanal-eal jolil",
  "block.minecraft.banner.triangles_top.lime": "Yoxyoxtik tanal-eal jolil",
  "block.minecraft.banner.triangles_top.magenta": "Tsojtsojtik tanal-eal jolil",
  "block.minecraft.banner.triangles_top.orange": "K'onk'ontik tanal-eal jolil",
  "block.minecraft.banner.triangles_top.pink": "Tsojtsojtik tanal-eal jolil",
  "block.minecraft.banner.triangles_top.purple": "Ik'pok'an tanal-eal jolil",
  "block.minecraft.banner.triangles_top.red": "Tsajal tanal-eal jolil",
  "block.minecraft.banner.triangles_top.white": "Sakil tanal-eal jolil",
  "block.minecraft.banner.triangles_top.yellow": "K'anal tanal-eal jolil",
  "block.minecraft.barrel": "Varil",
  "block.minecraft.barrier": "Varera",
  "block.minecraft.basalt": "Vasalto",
  "block.minecraft.beacon": "Jaro",
  "block.minecraft.beacon.primary": "Ba'yel ju'el",
  "block.minecraft.beacon.secondary": "Xchibal ju'el",
  "block.minecraft.bed.no_sleep": "Xu' no'ox chavay ta ak'obal o ta ik'al-o'etik",
  "block.minecraft.bed.not_safe": "Mu xu' xavay tana: oy monstroetik ta nopol",
  "block.minecraft.bed.obstructed": "Sukbil li tem li'e",
  "block.minecraft.bed.occupied": "Mu xokol li tem li'e",
  "block.minecraft.bed.too_far_away": "Mu xu' xavay tana: toj nom li teme",
  "block.minecraft.bedrock": "Bats'i ton",
  "block.minecraft.bee_nest": "Na pom",
  "block.minecraft.beehive": "Nail xchanul pom",
  "block.minecraft.beetroots": "Aselka",
  "block.minecraft.bell": "Kampana",
  "block.minecraft.big_dripleaf": "Muk'ta toyte'",
  "block.minecraft.big_dripleaf_stem": "Xch'ut muk'ta toyte'",
  "block.minecraft.birch_button": "Voton ta averul",
  "block.minecraft.birch_door": "Ti'na ta averul",
  "block.minecraft.birch_fence": "Mok ta averul",
  "block.minecraft.birch_fence_gate": "Ti' mok ta averul",
  "block.minecraft.birch_hanging_sign": "Jipiej leterero ta averul",
  "block.minecraft.birch_leaves": "Yanaltak averul",
  "block.minecraft.birch_log": "Chumante'el averul",
  "block.minecraft.birch_planks": "Tenelte'etik ta averul",
  "block.minecraft.birch_pressure_plate": "Net'obil ta averul",
  "block.minecraft.birch_sapling": "K'elom averul",
  "block.minecraft.birch_shelf": "Repisa ta averul",
  "block.minecraft.birch_sign": "Leterero ta averul",
  "block.minecraft.birch_slab": "Losa ta averul",
  "block.minecraft.birch_stairs": "Ixkalera ta averul",
  "block.minecraft.birch_trapdoor": "Ti' pets' ta averul",
  "block.minecraft.birch_wall_hanging_sign": "Jipiej leterero ta averul ta kubo",
  "block.minecraft.birch_wall_sign": "Leterero ta averul ta kubo",
  "block.minecraft.birch_wood": "Averul te'",
  "block.minecraft.black_banner": "Ik'al vantera",
  "block.minecraft.black_bed": "Ik'al tem",
  "block.minecraft.black_candle": "Ik'al kantela",
  "block.minecraft.black_candle_cake": "Pastel xchi'uk ik'al kantela",
  "block.minecraft.black_carpet": "Ik'al tapete",
  "block.minecraft.black_concrete": "Ik'al konkereto",
  "block.minecraft.black_concrete_powder": "Ik'al semento",
  "block.minecraft.black_glazed_terracotta": "Ik'al asulejo",
  "block.minecraft.black_shulker_box": "Ik'al kaxa yu'un shulker",
  "block.minecraft.black_stained_glass": "Ik'al nen",
  "block.minecraft.black_stained_glass_pane": "Ik'al panel nen",
  "block.minecraft.black_terracotta": "Ik'al lakal ach'el",
  "block.minecraft.black_wool": "Ik'al tsots",
  "block.minecraft.blackstone": "Ik'alton",
  "block.minecraft.blackstone_slab": "Losa ta ik'alton",
  "block.minecraft.blackstone_stairs": "Ixkalera ta ik'alton",
  "block.minecraft.blackstone_wall": "Muro ta ik'alton",
  "block.minecraft.blast_furnace": "Muk'ta jorno",
  "block.minecraft.blue_banner": "Yaxal vantera",
  "block.minecraft.blue_bed": "Yaxal tem",
  "block.minecraft.blue_candle": "Yaxal kantela",
  "block.minecraft.blue_candle_cake": "Pastel xchi'uk yaxal kantela",
  "block.minecraft.blue_carpet": "Yaxal tapete",
  "block.minecraft.blue_concrete": "Yaxal konkereto",
  "block.minecraft.blue_concrete_powder": "Yaxal semento",
  "block.minecraft.blue_glazed_terracotta": "Yaxal asulejo",
  "block.minecraft.blue_ice": "Yaxal taiv",
  "block.minecraft.blue_orchid": "Yaxal ech'",
  "block.minecraft.blue_shulker_box": "Yaxal kaxa yu'un shulker",
  "block.minecraft.blue_stained_glass": "Yaxal nen",
  "block.minecraft.blue_stained_glass_pane": "Yaxal panel nen",
  "block.minecraft.blue_terracotta": "Yaxal lakal ach'el",
  "block.minecraft.blue_wool": "Yaxal tsots",
  "block.minecraft.bone_block": "Kubo bak",
  "block.minecraft.bookshelf": "Kajanab",
  "block.minecraft.brain_coral": "Chinab nabalte'",
  "block.minecraft.brain_coral_block": "Kubo chinab nabalte'",
  "block.minecraft.brain_coral_fan": "Chinab korkonia",
  "block.minecraft.brain_coral_wall_fan": "Chinab korkonia ta kubo",
  "block.minecraft.brewing_stand": "Chijobil",
  "block.minecraft.brick_slab": "Losa ta latriyoetik",
  "block.minecraft.brick_stairs": "Ixkalera ta latriyoetik",
  "block.minecraft.brick_wall": "Muro ta latriyoetik",
  "block.minecraft.bricks": "Latriyoetik",
  "block.minecraft.brown_banner": "K'anch'etan vantera",
  "block.minecraft.brown_bed": "K'anch'etan tem",
  "block.minecraft.brown_candle": "K'anch'etan kantela",
  "block.minecraft.brown_candle_cake": "Pastel xchi'uk k'anch'etan kantela",
  "block.minecraft.brown_carpet": "K'anch'etan tapete",
  "block.minecraft.brown_concrete": "K'anch'etan konkereto",
  "block.minecraft.brown_concrete_powder": "K'anch'etan semento",
  "block.minecraft.brown_glazed_terracotta": "K'anch'etan asulejo",
  "block.minecraft.brown_mushroom": "K'anch'etan moni'",
  "block.minecraft.brown_mushroom_block": "Kubo ta k'anch'etan moni'",
  "block.minecraft.brown_shulker_box": "K'anch'etan kaxa yu'un shulker",
  "block.minecraft.brown_stained_glass": "K'anch'etan nen",
  "block.minecraft.brown_stained_glass_pane": "K'anch'etan panel nen",
  "block.minecraft.brown_terracotta": "K'anch'etan lakal ach'el",
  "block.minecraft.brown_wool": "K'anch'etan tsots",
  "block.minecraft.bubble_column": "Kolumna balbunel",
  "block.minecraft.bubble_coral": "Balbunel nabalte'",
  "block.minecraft.bubble_coral_block": "Kubo ta balbunel nabalte'",
  "block.minecraft.bubble_coral_fan": "Balbunel korkonia",
  "block.minecraft.bubble_coral_wall_fan": "Balbunel korkonia ta kubo",
  "block.minecraft.budding_amethyst": "Jlok'esvanej amatista",
  "block.minecraft.bush": "Xk'ib",
  "block.minecraft.cactus": "Petok",
  "block.minecraft.cactus_flower": "Nichim petok",
  "block.minecraft.cake": "Pastel",
  "block.minecraft.calcite": "Kalsita",
  "block.minecraft.calibrated_sculk_sensor": "Tsinbil a'iob-sculk",
  "block.minecraft.campfire": "K'ok'",
  "block.minecraft.candle": "Kantela",
  "block.minecraft.candle_cake": "Pastel xchi'uk kantela",
  "block.minecraft.carrots": "Sanaoriaetik",
  "block.minecraft.cartography_table": "Mexa ta lok'tael",
  "block.minecraft.carved_pumpkin": "Josbil ch'um",
  "block.minecraft.cauldron": "Kaltera",
  "block.minecraft.cave_air": "Ch'enal ik'",
  "block.minecraft.cave_vines": "Ch'enal ak'etik",
  "block.minecraft.cave_vines_plant": "Ch'enal ak'",
  "block.minecraft.chain": "Karena",
  "block.minecraft.chain_command_block": "Kubo ta mantal karena",
  "block.minecraft.cherry_button": "Voton ta ch'ixtot",
  "block.minecraft.cherry_door": "Ti'na ta ch'ixtot",
  "block.minecraft.cherry_fence": "Mok ta ch'ixtot",
  "block.minecraft.cherry_fence_gate": "Ti' mok ta ch'ixtot",
  "block.minecraft.cherry_hanging_sign": "Jipiej leterero ta ch'ixtot",
  "block.minecraft.cherry_leaves": "Yanaltak ch'ixtot",
  "block.minecraft.cherry_log": "Chumante'el ch'ixtot",
  "block.minecraft.cherry_planks": "Tenelte'etik ta ch'ixtot",
  "block.minecraft.cherry_pressure_plate": "Net'obil ta ch'ixtot",
  "block.minecraft.cherry_sapling": "K'elom ch'ixtot",
  "block.minecraft.cherry_shelf": "Repisa ta ch'ixtot",
  "block.minecraft.cherry_sign": "Leterero ta ch'ixtot",
  "block.minecraft.cherry_slab": "Losa ta ch'ixtot",
  "block.minecraft.cherry_stairs": "Ixkalera ta ch'ixtot",
  "block.minecraft.cherry_trapdoor": "Ti' pets' ta ch'ixtot",
  "block.minecraft.cherry_wall_hanging_sign": "Jipiej leterero ta ch'ixtot ta kubo",
  "block.minecraft.cherry_wall_sign": "Leterero ta ch'ixtot ta kubo",
  "block.minecraft.cherry_wood": "Ch'ixtot te'",
  "block.minecraft.chest": "Kaxa",
  "block.minecraft.chipped_anvil": "Sokem yunke",
  "block.minecraft.chiseled_bookshelf": "Chak'alte'",
  "block.minecraft.chiseled_copper": "Lok'tabil k'anal k'unil tak'in",
  "block.minecraft.chiseled_deepslate": "Lok'tabil ik'pulanton",
  "block.minecraft.chiseled_nether_bricks": "Lok'tabil Nether latriyoetik",
  "block.minecraft.chiseled_polished_blackstone": "Lok'tabil ch'ulbil ik'alton",
  "block.minecraft.chiseled_quartz_block": "Lok'tabil kuarso",
  "block.minecraft.chiseled_red_sandstone": "Lok'tabil tsajal areniska",
  "block.minecraft.chiseled_resin_bricks": "Lok'tabil latriyoetik ta xuch'",
  "block.minecraft.chiseled_sandstone": "Lok'tabil areniska",
  "block.minecraft.chiseled_stone_bricks": "Lok'tabil latriyoetik ta ton",
  "block.minecraft.chiseled_tuff": "Lok'tabil tova",
  "block.minecraft.chiseled_tuff_bricks": "Lok'tabil latriyoetik ta tova",
  "block.minecraft.chorus_flower": "Chorusnichim",
  "block.minecraft.chorus_plant": "Choruste'",
  "block.minecraft.clay": "Lum",
  "block.minecraft.closed_eyeblossom": "Makal satilal nichim",
  "block.minecraft.coal_block": "Kubo ta ak'al",
  "block.minecraft.coal_ore": "Mineral ta ak'al",
  "block.minecraft.coarse_dirt": "Chamem lum",
  "block.minecraft.cobbled_deepslate": "Josbil ik'pulanton",
  "block.minecraft.cobbled_deepslate_slab": "Losa ta josbil ik'pulanton",
  "block.minecraft.cobbled_deepslate_stairs": "Ixkalera ta josbil ik'pulanton",
  "block.minecraft.cobbled_deepslate_wall": "Muro ta josbil ik'pulanton",
  "block.minecraft.cobblestone": "Josbil ton",
  "block.minecraft.cobblestone_slab": "Losa ta josbil ton",
  "block.minecraft.cobblestone_stairs": "Ixkalera ta josbil ton",
  "block.minecraft.cobblestone_wall": "Muro ta josbil ton",
  "block.minecraft.cobweb": "Na'om",
  "block.minecraft.cocoa": "Kokov",
  "block.minecraft.command_block": "Kubo ta mantal",
  "block.minecraft.comparator": "Ko'oltasobil ta redstone",
  "block.minecraft.composter": "Spasob k'a'al lum",
  "block.minecraft.conduit": "Spasob kanalisar",
  "block.minecraft.copper_bars": "Te' ta k'anal k'unil tak'inetik",
  "block.minecraft.copper_block": "Kubo ta k'anal k'unil tak'in",
  "block.minecraft.copper_bulb": "Joko ta k'anal k'unil tak'in",
  "block.minecraft.copper_chain": "Karena ta k'anal k'unil tak'in",
  "block.minecraft.copper_chest": "Kaxa ta k'anal k'unil tak'in",
  "block.minecraft.copper_door": "Ti'na ta k'anal k'unil tak'in",
  "block.minecraft.copper_golem_statue": "Eskultura ta jchabivanej ta k'anal k'unil tak'in",
  "block.minecraft.copper_grate": "Rejiya ta k'anal k'unil tak'in",
  "block.minecraft.copper_lantern": "Joko ta k'anal k'unil tak'in",
  "block.minecraft.copper_ore": "Mineral ta k'anal k'unil tak'in",
  "block.minecraft.copper_torch": "Jch'ob toj ta k'anal k'unil tak'in",
  "block.minecraft.copper_trapdoor": "Ti' pets' ta k'anal k'unil tak'in",
  "block.minecraft.copper_wall_torch": "Jch'ob toj ta k'anal k'unil tak'in ta kubo",
  "block.minecraft.cornflower": "Asiano",
  "block.minecraft.cracked_deepslate_bricks": "Jomol latriyoetik ta ik'pulanton",
  "block.minecraft.cracked_deepslate_tiles": "Jomol asulejoetik ta ik'pulanton",
  "block.minecraft.cracked_nether_bricks": "Jomol Nether latriyoetik",
  "block.minecraft.cracked_polished_blackstone_bricks": "Latriyoetik ta jomol ch'ulbil ik'alton",
  "block.minecraft.cracked_stone_bricks": "Jomol latriyoetik ta ton",
  "block.minecraft.crafter": "Meltsanobil",
  "block.minecraft.crafting_table": "Mexa ta meltsanel",
  "block.minecraft.creaking_heart": "Yo'onton jch'ak'ak'etajel",
  "block.minecraft.creeper_head": "Sjol creeper",
  "block.minecraft.creeper_wall_head": "Sjol creeper ta kubo",
  "block.minecraft.crimson_button": "Tsajal voton",
  "block.minecraft.crimson_door": "Tsajal ti'na",
  "block.minecraft.crimson_fence": "Tsajal mok",
  "block.minecraft.crimson_fence_gate": "Tsajal ti' mok",
  "block.minecraft.crimson_fungus": "Nether moni'",
  "block.minecraft.crimson_hanging_sign": "Tsajal jipiej leterero",
  "block.minecraft.crimson_hyphae": "Tsajal ipax",
  "block.minecraft.crimson_nylium": "Tsajal neselio",
  "block.minecraft.crimson_planks": "Tsajal tenelte'etik",
  "block.minecraft.crimson_pressure_plate": "Tsajal net'obil",
  "block.minecraft.crimson_roots": "Tsajal ibeletik",
  "block.minecraft.crimson_shelf": "Tsajal repisa",
  "block.minecraft.crimson_sign": "Tsajal leterero",
  "block.minecraft.crimson_slab": "Tsajal losa",
  "block.minecraft.crimson_stairs": "Tsajal ixkalera",
  "block.minecraft.crimson_stem": "Tsajal ch'util",
  "block.minecraft.crimson_trapdoor": "Tsajal ti' pets'",
  "block.minecraft.crimson_wall_hanging_sign": "Tsajal jipiej leterero ta kubo",
  "block.minecraft.crimson_wall_sign": "Tsajal leterero ta kubo",
  "block.minecraft.crying_obsidian": "J-ok'el xik' xulem",
  "block.minecraft.cut_copper": "Mokol k'anal k'unil tak'in",
  "block.minecraft.cut_copper_slab": "Losa ta mokol k'anal k'unil tak'in",
  "block.minecraft.cut_copper_stairs": "Ixkalera ta mokol k'anal k'unil tak'in",
  "block.minecraft.cut_red_sandstone": "Mokol tsajal areniska",
  "block.minecraft.cut_red_sandstone_slab": "Losa ta mokol tsajal areniska",
  "block.minecraft.cut_sandstone": "Mokol areniska",
  "block.minecraft.cut_sandstone_slab": "Losa ta mokol areniska",
  "block.minecraft.cyan_banner": "Yax-elan vantera",
  "block.minecraft.cyan_bed": "Yax-elan tem",
  "block.minecraft.cyan_candle": "Yax-elan kantela",
  "block.minecraft.cyan_candle_cake": "Pastel xchi'uk yax-elan kantela",
  "block.minecraft.cyan_carpet": "Yax-elan tapete",
  "block.minecraft.cyan_concrete": "Yax-elan konkereto",
  "block.minecraft.cyan_concrete_powder": "Yax-elan semento",
  "block.minecraft.cyan_glazed_terracotta": "Yax-elan asulejo",
  "block.minecraft.cyan_shulker_box": "Yax-elan kaxa yu'un shulker",
  "block.minecraft.cyan_stained_glass": "Yax-elan nen",
  "block.minecraft.cyan_stained_glass_pane": "Yax-elan panel nen",
  "block.minecraft.cyan_terracotta": "Yax-elan lakal ach'el",
  "block.minecraft.cyan_wool": "Yax-elan tsots",
  "block.minecraft.damaged_anvil": "Toj sokem yunke",
  "block.minecraft.dandelion": "Amarkon",
  "block.minecraft.dark_oak_button": "Voton ta ik'pulan tulan",
  "block.minecraft.dark_oak_door": "Ti'na ta ik'pulan tulan",
  "block.minecraft.dark_oak_fence": "Mok ta ik'pulan tulan",
  "block.minecraft.dark_oak_fence_gate": "Ti' mok ta ik'pulan tulan",
  "block.minecraft.dark_oak_hanging_sign": "Jipiej leterero ta ik'pulan tulan",
  "block.minecraft.dark_oak_leaves": "Yanaltak ik'pulan tulan",
  "block.minecraft.dark_oak_log": "Chumante'el ik'pulan tulan",
  "block.minecraft.dark_oak_planks": "Tenelte'etik ta ik'pulan tulan",
  "block.minecraft.dark_oak_pressure_plate": "Net'obil ta ik'pulan tulan",
  "block.minecraft.dark_oak_sapling": "K'elom ik'pulan tulan",
  "block.minecraft.dark_oak_shelf": "Repisa ta ik'pulan tulan",
  "block.minecraft.dark_oak_sign": "Leterero ta ik'pulan tulan",
  "block.minecraft.dark_oak_slab": "Losa ta ik'pulan tulan",
  "block.minecraft.dark_oak_stairs": "Ixkalera ta ik'pulan tulan",
  "block.minecraft.dark_oak_trapdoor": "Ti' pets' ta ik'pulan tulan",
  "block.minecraft.dark_oak_wall_hanging_sign": "Jipiej leterero ta ik'pulan tulan ta kubo",
  "block.minecraft.dark_oak_wall_sign": "Leterero ta ik'pulan tulan ta kubo",
  "block.minecraft.dark_oak_wood": "Ik'pulan tulan te'",
  "block.minecraft.dark_prismarine": "Ik'pulan pirismarina",
  "block.minecraft.dark_prismarine_slab": "Losa ta ik'pulan pirismarina",
  "block.minecraft.dark_prismarine_stairs": "Ixkalera ta ik'pulan pirismarina",
  "block.minecraft.daylight_detector": "Ya'iob xojobal k'ak'al",
  "block.minecraft.dead_brain_coral": "Chamem chinab nabalte'",
  "block.minecraft.dead_brain_coral_block": "Kubo ta chamem chinab nabalte'",
  "block.minecraft.dead_brain_coral_fan": "Chamem chinab korkonia",
  "block.minecraft.dead_brain_coral_wall_fan": "Chamem chinab korkonia ta kubo",
  "block.minecraft.dead_bubble_coral": "Chamem balbunel nabalte'",
  "block.minecraft.dead_bubble_coral_block": "Kubo ta chamem balbunel nabalte'",
  "block.minecraft.dead_bubble_coral_fan": "Chamem balbunel korkonia",
  "block.minecraft.dead_bubble_coral_wall_fan": "Chamem balbunel korkonia ta kubo",
  "block.minecraft.dead_bush": "Takin xk'ib",
  "block.minecraft.dead_fire_coral": "Chamem k'ok' nabalte'",
  "block.minecraft.dead_fire_coral_block": "Kubo ta chamem k'ok' nabalte'",
  "block.minecraft.dead_fire_coral_fan": "Chamem k'ok' korkonia",
  "block.minecraft.dead_fire_coral_wall_fan": "Chamem k'ok' korkonia ta kubo",
  "block.minecraft.dead_horn_coral": "Chamem kachu nabalte'",
  "block.minecraft.dead_horn_coral_block": "Kubo ta chamem kachu nabalte'",
  "block.minecraft.dead_horn_coral_fan": "Chamem kachu korkonia",
  "block.minecraft.dead_horn_coral_wall_fan": "Chamem kachu korkonia ta kubo",
  "block.minecraft.dead_tube_coral": "Chamem tubo nabalte'",
  "block.minecraft.dead_tube_coral_block": "Kubo ta chamem tubo nabalte'",
  "block.minecraft.dead_tube_coral_fan": "Chamem tubo korkonia",
  "block.minecraft.dead_tube_coral_wall_fan": "Chamem tubo korkonia ta kubo",
  "block.minecraft.decorated_pot": "Xalu'",
  "block.minecraft.deepslate": "Ik'pulanton",
  "block.minecraft.deepslate_brick_slab": "Losa ta latriyoetik ta ik'pulanton",
  "block.minecraft.deepslate_brick_stairs": "Ixkalera ta latriyoetik ta ik'pulanton",
  "block.minecraft.deepslate_brick_wall": "Muro ta latriyoetik ta ik'pulanton",
  "block.minecraft.deepslate_bricks": "Latriyoetik ta ik'pulanton",
  "block.minecraft.deepslate_coal_ore": "Mineral ta ak'al ta ik'pulanton",
  "block.minecraft.deepslate_copper_ore": "Mineral ta k'anal k'unil tak'in ta ik'pulanton",
  "block.minecraft.deepslate_diamond_ore": "Mineral ta riamante ta ik'pulanton",
  "block.minecraft.deepslate_emerald_ore": "Mineral ta esmeralta ta ik'pulanton",
  "block.minecraft.deepslate_gold_ore": "Mineral ta k'anal tak'in ta ik'pulanton",
  "block.minecraft.deepslate_iron_ore": "Mineral ta tak'in ta ik'pulanton",
  "block.minecraft.deepslate_lapis_ore": "Mineral ta lapislasuli ta ik'pulanton",
  "block.minecraft.deepslate_redstone_ore": "Mineral ta redstone ta ik'pulanton",
  "block.minecraft.deepslate_tile_slab": "Losa ta asulejo ta ik'pulanton",
  "block.minecraft.deepslate_tile_stairs": "Ixkalera ta asulejo ta ik'pulanton",
  "block.minecraft.deepslate_tile_wall": "Muro ta asulejo ta ik'pulanton",
  "block.minecraft.deepslate_tiles": "Asulejo ta ik'pulanton",
  "block.minecraft.detector_rail": "Xanebal tael",
  "block.minecraft.diamond_block": "Kubo ta riamante",
  "block.minecraft.diamond_ore": "Mineral ta riamante",
  "block.minecraft.diorite": "Tiorita",
  "block.minecraft.diorite_slab": "Losa ta tiorita",
  "block.minecraft.diorite_stairs": "Ixkalera ta tiorita",
  "block.minecraft.diorite_wall": "Muro ta tiorita",
  "block.minecraft.dirt": "Lum",
  "block.minecraft.dirt_path": "Lumil be",
  "block.minecraft.dispenser": "Pukobil",
  "block.minecraft.dragon_egg": "Ston muk'ta ain",
  "block.minecraft.dragon_head": "Sjol muk'ta ain",
  "block.minecraft.dragon_wall_head": "Sjol muk'ta ain ta kubo",
  "block.minecraft.dried_ghast": "Takin ghast",
  "block.minecraft.dried_kelp_block": "Kubo ta takin alka",
  "block.minecraft.dripstone_block": "Chu'ch'enal kubo",
  "block.minecraft.dropper": "Tenobil",
  "block.minecraft.emerald_block": "Kubo ta esmeralta",
  "block.minecraft.emerald_ore": "Mineral ta esmeralta",
  "block.minecraft.enchanting_table": "Mexa ta kapel",
  "block.minecraft.end_gateway": "Ti' End",
  "block.minecraft.end_portal": "End ochebal",
  "block.minecraft.end_portal_frame": "Smarko ochebal ta End",
  "block.minecraft.end_rod": "End te'",
  "block.minecraft.end_stone": "End ton",
  "block.minecraft.end_stone_brick_slab": "Losa latriyoetik ta End ton",
  "block.minecraft.end_stone_brick_stairs": "Ixkalera ta latriyoetik ta End ton",
  "block.minecraft.end_stone_brick_wall": "Muro ta latriyoetik ta End ton",
  "block.minecraft.end_stone_bricks": "Latriyoetik ta End ton",
  "block.minecraft.ender_chest": "Ender kaxa",
  "block.minecraft.exposed_chiseled_copper": "K'oxetajesbil lok'tabil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper": "K'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_bars": "Baraetik ta k'oxetajesbil k'anal k'unil tak'inetik",
  "block.minecraft.exposed_copper_bulb": "Joko ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_chain": "Karena ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_chest": "Kaxa ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_door": "Ti'na ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_golem_statue": "Eskultura ta k'oxetajesbil jchabivanej ta k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_grate": "Rejiya ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_lantern": "Joko ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_copper_trapdoor": "Ti' pets' ta k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.exposed_cut_copper": "K'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.exposed_cut_copper_slab": "Losa ta k'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.exposed_cut_copper_stairs": "Ixkalera ta k'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.exposed_lightning_rod": "K'oxetajesbil yikob anjel",
  "block.minecraft.farmland": "Lum ta ts'un",
  "block.minecraft.fern": "Tsib",
  "block.minecraft.fire": "K'ok'",
  "block.minecraft.fire_coral": "K'ok' nabalte'",
  "block.minecraft.fire_coral_block": "Kubo ta k'ok' nabalte'",
  "block.minecraft.fire_coral_fan": "K'ok' korkonia",
  "block.minecraft.fire_coral_wall_fan": "K'ok' korkonia ta kubo",
  "block.minecraft.firefly_bush": "Xk'ib xchi'uk kukayetik",
  "block.minecraft.fletching_table": "Mexa ta alkolal",
  "block.minecraft.flower_pot": "Maseta",
  "block.minecraft.flowering_azalea": "Nichimajem alasea",
  "block.minecraft.flowering_azalea_leaves": "Yanaltak nichimajem alasea",
  "block.minecraft.frogspawn": "Ton pok'pok'",
  "block.minecraft.frosted_ice": "Taiv",
  "block.minecraft.furnace": "Jorno",
  "block.minecraft.gilded_blackstone": "Yoroal ik'alton",
  "block.minecraft.glass": "Nen",
  "block.minecraft.glass_pane": "Panel nen",
  "block.minecraft.glow_lichen": "Nop'ol liken",
  "block.minecraft.glowstone": "Nop'olton",
  "block.minecraft.gold_block": "Kubo ta k'anal tak'in",
  "block.minecraft.gold_ore": "Mineral ta k'anal tak'in",
  "block.minecraft.golden_dandelion": "Yoroal amarkon",
  "block.minecraft.granite": "Karanito",
  "block.minecraft.granite_slab": "Losa ta karanito",
  "block.minecraft.granite_stairs": "Ixkalera ta karanito",
  "block.minecraft.granite_wall": "Muro ta karanito",
  "block.minecraft.grass": "Yaxal",
  "block.minecraft.grass_block": "Kubo ta yaxal",
  "block.minecraft.gravel": "Xixibton",
  "block.minecraft.gray_banner": "K'anch'etan vantera",
  "block.minecraft.gray_bed": "K'anch'etan tem",
  "block.minecraft.gray_candle": "K'anch'etan kantela",
  "block.minecraft.gray_candle_cake": "Pastel xchi'uk k'anch'etan kantela",
  "block.minecraft.gray_carpet": "K'anch'etan tapete",
  "block.minecraft.gray_concrete": "Konkereto",
  "block.minecraft.gray_concrete_powder": "Semento",
  "block.minecraft.gray_glazed_terracotta": "K'anch'etan asulejo",
  "block.minecraft.gray_shulker_box": "K'anch'etan kaxa yu'un shulker",
  "block.minecraft.gray_stained_glass": "K'anch'etan nen",
  "block.minecraft.gray_stained_glass_pane": "K'anch'etan panel ta nen",
  "block.minecraft.gray_terracotta": "K'anch'etan lakal ach'el",
  "block.minecraft.gray_wool": "K'anch'etan tsots",
  "block.minecraft.green_banner": "Yaxal vantera",
  "block.minecraft.green_bed": "Yaxal tem",
  "block.minecraft.green_candle": "Yaxal kantela",
  "block.minecraft.green_candle_cake": "Pastel xchi'uk yaxal kantela",
  "block.minecraft.green_carpet": "Yaxal tapete",
  "block.minecraft.green_concrete": "Yaxal konkereto",
  "block.minecraft.green_concrete_powder": "Yaxal semento",
  "block.minecraft.green_glazed_terracotta": "Yaxal asulejo",
  "block.minecraft.green_shulker_box": "Yaxal kaxa yu'un shulker",
  "block.minecraft.green_stained_glass": "Yaxal nen",
  "block.minecraft.green_stained_glass_pane": "Yaxal panel ta nen",
  "block.minecraft.green_terracotta": "Yaxal lakal ach'el",
  "block.minecraft.green_wool": "Yaxal tsots",
  "block.minecraft.grindstone": "Juxum",
  "block.minecraft.hanging_roots": "Jipiej ibeletik",
  "block.minecraft.hay_block": "Chukul anjobel",
  "block.minecraft.heavy_core": "Alal util",
  "block.minecraft.heavy_weighted_pressure_plate": "Net'obil sventa ep alalil",
  "block.minecraft.honey_block": "Kubo ta ajapom",
  "block.minecraft.honeycomb_block": "Kubo ta akov",
  "block.minecraft.hopper": "Malobil",
  "block.minecraft.horn_coral": "Kachu nabalte'",
  "block.minecraft.horn_coral_block": "Kubo ta kachu nabalte'",
  "block.minecraft.horn_coral_fan": "Kachu korkonia",
  "block.minecraft.horn_coral_wall_fan": "Kachu korkonia ta kubo",
  "block.minecraft.ice": "Taiv",
  "block.minecraft.infested_chiseled_stone_bricks": "Xujul lok'tabil latriyoetik ta ton",
  "block.minecraft.infested_cobblestone": "Xujul josbil ton",
  "block.minecraft.infested_cracked_stone_bricks": "Xujul jomol latriyoetik ta ton",
  "block.minecraft.infested_deepslate": "Xujul ik'pulanton",
  "block.minecraft.infested_mossy_stone_bricks": "Xujul tsonte'al latriyoetik ta ton",
  "block.minecraft.infested_stone": "Xujul ton",
  "block.minecraft.infested_stone_bricks": "Xujul latriyoetik ta ton",
  "block.minecraft.iron_bars": "Baraetik",
  "block.minecraft.iron_block": "Kubo ta tak'in",
  "block.minecraft.iron_chain": "Karena",
  "block.minecraft.iron_door": "Ti'na ta tak'in",
  "block.minecraft.iron_ore": "Mineral ta tak'in",
  "block.minecraft.iron_trapdoor": "Ti' pets' ta tak'in",
  "block.minecraft.jack_o_lantern": "K'inal ch'um",
  "block.minecraft.jigsaw": "Kubo ta rompekabesas",
  "block.minecraft.jukebox": "Vabajesobil",
  "block.minecraft.jungle_button": "Jabnaltikal voton",
  "block.minecraft.jungle_door": "Jabnaltikal ti'na",
  "block.minecraft.jungle_fence": "Jabnaltikal mok",
  "block.minecraft.jungle_fence_gate": "Jabnaltikal ti' mok",
  "block.minecraft.jungle_hanging_sign": "Jabnaltikal jipiej leterero",
  "block.minecraft.jungle_leaves": "Yanaltak jabnal",
  "block.minecraft.jungle_log": "Jabnaltikal chumante'",
  "block.minecraft.jungle_planks": "Jabnaltikal tenelte'etik",
  "block.minecraft.jungle_pressure_plate": "Jabnaltikal net'obil",
  "block.minecraft.jungle_sapling": "Jabnaltikal k'elom",
  "block.minecraft.jungle_shelf": "Jabnaltikal repisa",
  "block.minecraft.jungle_sign": "Jabnal leterero",
  "block.minecraft.jungle_slab": "Jabnaltikal losa",
  "block.minecraft.jungle_stairs": "Jabnaltikal ixkalera",
  "block.minecraft.jungle_trapdoor": "Jabnaltikal ti' pets'",
  "block.minecraft.jungle_wall_hanging_sign": "Jabnaltikal jipiej leterero ta kubo",
  "block.minecraft.jungle_wall_sign": "Jabnaltikal leterero ta kubo",
  "block.minecraft.jungle_wood": "Jabnaltikal te'",
  "block.minecraft.kelp": "Alka",
  "block.minecraft.kelp_plant": "Xch'ut alka",
  "block.minecraft.ladder": "Tek'omte'",
  "block.minecraft.lantern": "Joko",
  "block.minecraft.lapis_block": "Kubo ta lapislasuli",
  "block.minecraft.lapis_ore": "Mineral ta lapislasuli",
  "block.minecraft.large_amethyst_bud": "Muk'ta lok'el amatista",
  "block.minecraft.large_fern": "Natil tsib",
  "block.minecraft.lava": "Tsuk'",
  "block.minecraft.lava_cauldron": "Kaltera xchi'uk tsuk'",
  "block.minecraft.leaf_litter": "Ik'luman",
  "block.minecraft.lectern": "Atiril",
  "block.minecraft.lever": "Palanka",
  "block.minecraft.light": "Lus",
  "block.minecraft.light_blue_banner": "Yaxal vantera",
  "block.minecraft.light_blue_bed": "Yaxal tem",
  "block.minecraft.light_blue_candle": "Yaxal kantela",
  "block.minecraft.light_blue_candle_cake": "Pastel xchi'uk yaxal kantela",
  "block.minecraft.light_blue_carpet": "Yaxal tapete",
  "block.minecraft.light_blue_concrete": "Yaxal konkereto",
  "block.minecraft.light_blue_concrete_powder": "Yaxal semento",
  "block.minecraft.light_blue_glazed_terracotta": "Yaxal asulejo",
  "block.minecraft.light_blue_shulker_box": "Yaxal kaxa yu'un shulker",
  "block.minecraft.light_blue_stained_glass": "Yaxal nen",
  "block.minecraft.light_blue_stained_glass_pane": "Yaxal panel ta nen",
  "block.minecraft.light_blue_terracotta": "Yaxal lakal ach'el",
  "block.minecraft.light_blue_wool": "Yaxal tsots",
  "block.minecraft.light_gray_banner": "K'anch'etan vantera",
  "block.minecraft.light_gray_bed": "K'anch'etan tem",
  "block.minecraft.light_gray_candle": "K'anch'etan kantela",
  "block.minecraft.light_gray_candle_cake": "Pastel xchi'uk k'anch'etan kantela",
  "block.minecraft.light_gray_carpet": "K'anch'etan tapete",
  "block.minecraft.light_gray_concrete": "Konkereto",
  "block.minecraft.light_gray_concrete_powder": "Semento",
  "block.minecraft.light_gray_glazed_terracotta": "K'anch'etan asulejo",
  "block.minecraft.light_gray_shulker_box": "K'anch'etan kaxa yu'un shulker",
  "block.minecraft.light_gray_stained_glass": "K'anch'etan nen",
  "block.minecraft.light_gray_stained_glass_pane": "K'anch'etan panel ta nen",
  "block.minecraft.light_gray_terracotta": "K'anch'etan lakal ach'el",
  "block.minecraft.light_gray_wool": "K'anch'etan tsots",
  "block.minecraft.light_weighted_pressure_plate": "Net'obil sventa jutuk alalil",
  "block.minecraft.lightning_rod": "Yikob anjel",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Yoy ta soplej",
  "block.minecraft.lily_pad": "Sapalota",
  "block.minecraft.lime_banner": "Yoxyoxtik vantera",
  "block.minecraft.lime_bed": "Yoxyoxtik tem",
  "block.minecraft.lime_candle": "Yoxyoxtik kantela",
  "block.minecraft.lime_candle_cake": "Pastel xchi'uk yoxyoxtik kantela",
  "block.minecraft.lime_carpet": "Yoxyoxtik tapete",
  "block.minecraft.lime_concrete": "Yoxyoxtik konkereto",
  "block.minecraft.lime_concrete_powder": "Yoxyoxtik semento",
  "block.minecraft.lime_glazed_terracotta": "Yoxyoxtik asulejo",
  "block.minecraft.lime_shulker_box": "Yoxyoxtik kaxa yu'un shulker",
  "block.minecraft.lime_stained_glass": "Yoxyoxtik nen",
  "block.minecraft.lime_stained_glass_pane": "Yoxyoxtik panel ta nen",
  "block.minecraft.lime_terracotta": "Yoxyoxtik lakal ach'el",
  "block.minecraft.lime_wool": "Yoxyoxtik tsots",
  "block.minecraft.lodestone": "Maknetita",
  "block.minecraft.loom": "Abtejebal pok'",
  "block.minecraft.magenta_banner": "Tsojtsojtik vantera",
  "block.minecraft.magenta_bed": "Tsojtsojtik tem",
  "block.minecraft.magenta_candle": "Tsojtsojtik kantela",
  "block.minecraft.magenta_candle_cake": "Pastel xchi'uk tsojtsojtik kantela",
  "block.minecraft.magenta_carpet": "Tsojtsojtik tapete",
  "block.minecraft.magenta_concrete": "Tsojtsojtik konkereto",
  "block.minecraft.magenta_concrete_powder": "Tsojtsojtik semento",
  "block.minecraft.magenta_glazed_terracotta": "Tsojtsojtik asulejo",
  "block.minecraft.magenta_shulker_box": "Tsojtsojtik kaxa yu'un shulker",
  "block.minecraft.magenta_stained_glass": "Tsojtsojtik nen",
  "block.minecraft.magenta_stained_glass_pane": "Tsojtsojtik panel ta nen",
  "block.minecraft.magenta_terracotta": "Tsojtsojtik lakal ach'el",
  "block.minecraft.magenta_wool": "Tsojtsojtik tsots",
  "block.minecraft.magma_block": "Kubo ta makma",
  "block.minecraft.mangrove_button": "Voton ta ja'alte'",
  "block.minecraft.mangrove_door": "Ti'na ta ja'alte'",
  "block.minecraft.mangrove_fence": "Mok ta ja'alte'",
  "block.minecraft.mangrove_fence_gate": "Ti' mok ta ja'alte'",
  "block.minecraft.mangrove_hanging_sign": "Jipiej leterero ta ja'alte'",
  "block.minecraft.mangrove_leaves": "Yanaltak ja'alte'",
  "block.minecraft.mangrove_log": "Chumante'el ja'alte'",
  "block.minecraft.mangrove_planks": "Tenelte'etik ta ja'alte'etik",
  "block.minecraft.mangrove_pressure_plate": "Net'obil ta ja'alte'",
  "block.minecraft.mangrove_propagule": "Poropakulo ta ja'alte'",
  "block.minecraft.mangrove_roots": "Yi'beltak ja'alte'",
  "block.minecraft.mangrove_shelf": "Repisa ta ja'alte'",
  "block.minecraft.mangrove_sign": "Leterero ta ja'alte'",
  "block.minecraft.mangrove_slab": "Losa ta ja'alte'",
  "block.minecraft.mangrove_stairs": "Ixkalera ta ja'alte'",
  "block.minecraft.mangrove_trapdoor": "Ti' pets' ta ja'alte'",
  "block.minecraft.mangrove_wall_hanging_sign": "Jipiej leterero ta ja'alte' ta kubo",
  "block.minecraft.mangrove_wall_sign": "Leterero ta ja'alte' ta kubo",
  "block.minecraft.mangrove_wood": "Ja'alte'",
  "block.minecraft.medium_amethyst_bud": "Natil lok'el amatista",
  "block.minecraft.melon": "Xancha",
  "block.minecraft.melon_stem": "Ch'ut xancha",
  "block.minecraft.moss_block": "Kubo ta tsonte'",
  "block.minecraft.moss_carpet": "Tapete ta tsonte'",
  "block.minecraft.mossy_cobblestone": "Tsonte'al josbil ton",
  "block.minecraft.mossy_cobblestone_slab": "Losa ta tsonte'al josbil ton",
  "block.minecraft.mossy_cobblestone_stairs": "Ixkalera ta tsonte'al josbil ton",
  "block.minecraft.mossy_cobblestone_wall": "Muro ta tsonte'al josbil ton",
  "block.minecraft.mossy_stone_brick_slab": "Losa ta tsonte'al latriyoetik ta End ton",
  "block.minecraft.mossy_stone_brick_stairs": "Ixkalera ta tsonte'al latriyoetik ta End ton",
  "block.minecraft.mossy_stone_brick_wall": "Muro ta tsonte'al latriyoetik ta End ton",
  "block.minecraft.mossy_stone_bricks": "Latriyoetik ta tsonte'al ton",
  "block.minecraft.moving_piston": "Jbak'ej iston",
  "block.minecraft.mud": "Ach'el",
  "block.minecraft.mud_brick_slab": "Losa ta latriyoetik ta xamit",
  "block.minecraft.mud_brick_stairs": "Ixkalera ta latriyoetik ta xamit",
  "block.minecraft.mud_brick_wall": "Muro ta latriyoetik ta xamit",
  "block.minecraft.mud_bricks": "Latriyoetik ta xamit",
  "block.minecraft.muddy_mangrove_roots": "Ach'elal yi'beltak ja'alte'",
  "block.minecraft.mushroom_stem": "Ch'ut moni'",
  "block.minecraft.mycelium": "Miselio",
  "block.minecraft.nether_brick_fence": "Mok ta Nether latriyoetik",
  "block.minecraft.nether_brick_slab": "Losa ta Nether latriyoetik",
  "block.minecraft.nether_brick_stairs": "Ixkalera ta Nether latriyoetik",
  "block.minecraft.nether_brick_wall": "Muro ta latriyoetik ta Nether",
  "block.minecraft.nether_bricks": "Nether latriyoetik",
  "block.minecraft.nether_gold_ore": "Mineral ta Nether k'anal tak'in",
  "block.minecraft.nether_portal": "Nether ochebal",
  "block.minecraft.nether_quartz_ore": "Mineral ta Nether kuarso",
  "block.minecraft.nether_sprouts": "Nether k'elometik",
  "block.minecraft.nether_wart": "Nether ch'okte'",
  "block.minecraft.nether_wart_block": "Kubo ta Nether ch'okte'",
  "block.minecraft.netherite_block": "Kubo ta neterita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Sonal kubo",
  "block.minecraft.oak_button": "Voton ta tulan",
  "block.minecraft.oak_door": "Ti'na ta tulan",
  "block.minecraft.oak_fence": "Mok ta tulan",
  "block.minecraft.oak_fence_gate": "Ti' mok ta tulan",
  "block.minecraft.oak_hanging_sign": "Jipiej leterero ta tulan",
  "block.minecraft.oak_leaves": "Yanaltak tulan",
  "block.minecraft.oak_log": "Chumante'el tulan",
  "block.minecraft.oak_planks": "Tenelte'etik ta tulan",
  "block.minecraft.oak_pressure_plate": "Net'obil ta tulan",
  "block.minecraft.oak_sapling": "K'elom tulan",
  "block.minecraft.oak_shelf": "Repisa ta tulan",
  "block.minecraft.oak_sign": "Leterero ta tulan",
  "block.minecraft.oak_slab": "Losa ta tulan",
  "block.minecraft.oak_stairs": "Ixkalera ta tulan",
  "block.minecraft.oak_trapdoor": "Ti' pets' ta tulan",
  "block.minecraft.oak_wall_hanging_sign": "Jipiej leterero ta tulan ta kubo",
  "block.minecraft.oak_wall_sign": "Leterero ta tulan ta kubo",
  "block.minecraft.oak_wood": "Tulan te'",
  "block.minecraft.observer": "K'elobil",
  "block.minecraft.obsidian": "Xik' xulem",
  "block.minecraft.ochre_froglight": "K'anal nop'olkubo",
  "block.minecraft.ominous_banner": "Chopol vantera",
  "block.minecraft.open_eyeblossom": "Jamal satilal nichim",
  "block.minecraft.orange_banner": "K'onk'ontik vantera",
  "block.minecraft.orange_bed": "K'onk'ontik tem",
  "block.minecraft.orange_candle": "K'onk'ontik kantela",
  "block.minecraft.orange_candle_cake": "Pastel xchi'uk k'onk'ontik kantela",
  "block.minecraft.orange_carpet": "K'onk'ontik tapete",
  "block.minecraft.orange_concrete": "K'onk'ontik konkereto",
  "block.minecraft.orange_concrete_powder": "K'onk'ontik semento",
  "block.minecraft.orange_glazed_terracotta": "K'onk'ontik asulejo",
  "block.minecraft.orange_shulker_box": "K'onk'ontik kaxa yu'un shulker",
  "block.minecraft.orange_stained_glass": "K'onk'ontik nen",
  "block.minecraft.orange_stained_glass_pane": "K'onk'ontik panel ta nen",
  "block.minecraft.orange_terracotta": "K'onk'ontik lakal ach'el",
  "block.minecraft.orange_tulip": "K'onk'ontik tulipan",
  "block.minecraft.orange_wool": "K'onk'ontik tsots",
  "block.minecraft.oxeye_daisy": "Markarita",
  "block.minecraft.oxidized_chiseled_copper": "Kux lok'tabil k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper": "Kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_bars": "Baraetik ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_bulb": "Joko ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_chain": "Karena ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_chest": "Kaxa ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_door": "Ti'na ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_golem_statue": "Eskultura ta jchabivanej ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_grate": "Rejiya ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_lantern": "Joko ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_copper_trapdoor": "Ti' pets' ta kux k'anal k'unil tak'in",
  "block.minecraft.oxidized_cut_copper": "Kux mokol k'anal k'unil tak'in",
  "block.minecraft.oxidized_cut_copper_slab": "Losa ta kux mokol k'anal k'unil tak'in",
  "block.minecraft.oxidized_cut_copper_stairs": "Ixkalera ta kux mokol k'anal k'unil tak'in",
  "block.minecraft.oxidized_lightning_rod": "Kux yikob anjel",
  "block.minecraft.packed_ice": "Tsinil taiv",
  "block.minecraft.packed_mud": "Xamit",
  "block.minecraft.pale_hanging_moss": "Sakpak'an jipiej tsonte'",
  "block.minecraft.pale_moss_block": "Kubo ta sakpak'an tsonte'",
  "block.minecraft.pale_moss_carpet": "Tapetw ta sakpak'an tsonte'",
  "block.minecraft.pale_oak_button": "Voton ta sakpak'an tulan",
  "block.minecraft.pale_oak_door": "Ti'na ta sakpak'an tulan",
  "block.minecraft.pale_oak_fence": "Mok ta sakpak'an tulan",
  "block.minecraft.pale_oak_fence_gate": "Ti' mok ta sakpak'an tulan",
  "block.minecraft.pale_oak_hanging_sign": "Jipiej leterero ta sakpak'an tulan",
  "block.minecraft.pale_oak_leaves": "Yanaltak sakpak'an tulan",
  "block.minecraft.pale_oak_log": "Chumante'el sakpak'an tulan",
  "block.minecraft.pale_oak_planks": "Tenelte'etik ta sakpak'an tulan",
  "block.minecraft.pale_oak_pressure_plate": "Net'obil ta sakpak'an tulan",
  "block.minecraft.pale_oak_sapling": "K'elom sakpak'an tulan",
  "block.minecraft.pale_oak_shelf": "Repisa ta sakpak'an tulan",
  "block.minecraft.pale_oak_sign": "Leterero ta sakpak'an tulan",
  "block.minecraft.pale_oak_slab": "Losa ta sakpak'an tulan",
  "block.minecraft.pale_oak_stairs": "Ixkalera ta sakpak'an tulan",
  "block.minecraft.pale_oak_trapdoor": "Ti' pets' ta sakpak'an tulan",
  "block.minecraft.pale_oak_wall_hanging_sign": "Jipiej leterero ta sakpak'an tulan ta kubo",
  "block.minecraft.pale_oak_wall_sign": "Leterero ta sakpak'an tulan ta kubo",
  "block.minecraft.pale_oak_wood": "Sakpak'an tulan te'",
  "block.minecraft.pearlescent_froglight": "Ik'pok'an nop'olkubo",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Tanubem losa ta tulan",
  "block.minecraft.piglin_head": "Sjol piglin",
  "block.minecraft.piglin_wall_head": "Sjol piglin ta kubo",
  "block.minecraft.pink_banner": "Tsojtsojtik vantera",
  "block.minecraft.pink_bed": "Tsojtsojtik tem",
  "block.minecraft.pink_candle": "Tsojtsojtik kantela",
  "block.minecraft.pink_candle_cake": "Pastel xchi'uk tsojtsojtik kantela",
  "block.minecraft.pink_carpet": "Tsojtsojtik tapete",
  "block.minecraft.pink_concrete": "Tsojtsojtik konkereto",
  "block.minecraft.pink_concrete_powder": "Tsojtsojtik semento",
  "block.minecraft.pink_glazed_terracotta": "Tsojtsojtik asulejo",
  "block.minecraft.pink_petals": "Tsojtsojtik nichimetik",
  "block.minecraft.pink_shulker_box": "Tsojtsojtik kaxa yu'un shulker",
  "block.minecraft.pink_stained_glass": "Tsojtsojtik nen",
  "block.minecraft.pink_stained_glass_pane": "Tsojtsojtik panel ta nen",
  "block.minecraft.pink_terracotta": "Tsojtsojtik lakal ach'el",
  "block.minecraft.pink_tulip": "Tsojtsojtik tulipan",
  "block.minecraft.pink_wool": "Tsojtsojtik tsots",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Sjol piston",
  "block.minecraft.pitcher_crop": "Ts'un binalte'",
  "block.minecraft.pitcher_plant": "Binalte'",
  "block.minecraft.player_head": "Sjol jtajimol",
  "block.minecraft.player_head.named": "Sjol %s",
  "block.minecraft.player_wall_head": "Sjol jtajimol ta kubo",
  "block.minecraft.podzol": "Ch'ajil lum",
  "block.minecraft.pointed_dripstone": "Ts'ubts'ub chu'ch'en",
  "block.minecraft.polished_andesite": "Ch'ulbil antesita",
  "block.minecraft.polished_andesite_slab": "Losa ta ch'ulbil antesita",
  "block.minecraft.polished_andesite_stairs": "Ixkalera ta ch'ulbil antesita",
  "block.minecraft.polished_basalt": "Ch'ulbil vasalto",
  "block.minecraft.polished_blackstone": "Ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_brick_slab": "Losa ta latriyoetik ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_brick_stairs": "Ixkalera ta latriyoetik ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_brick_wall": "Muro ta latriyoetik ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_bricks": "Latriyoetik ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_button": "Voton ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_pressure_plate": "Net'obil ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_slab": "Losa ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_stairs": "Ixkalera ta ch'ulbil ik'alton",
  "block.minecraft.polished_blackstone_wall": "Muro ta ch'ulbil ik'alton",
  "block.minecraft.polished_deepslate": "Ch'ulbil ik'pulanton",
  "block.minecraft.polished_deepslate_slab": "Losa ta ch'ulbil ik'pulanton",
  "block.minecraft.polished_deepslate_stairs": "Ixkalera ta ch'ulbil ik'pulanton",
  "block.minecraft.polished_deepslate_wall": "Muro ta ch'ulbil ik'pulanton",
  "block.minecraft.polished_diorite": "Ch'ulbil tiorita",
  "block.minecraft.polished_diorite_slab": "Losa ta ch'ulbil tiorita",
  "block.minecraft.polished_diorite_stairs": "Ixkalera ta ch'ulbil ik'pulanton",
  "block.minecraft.polished_granite": "Ch'ulbil karanito",
  "block.minecraft.polished_granite_slab": "Losa ta ch'ulbil karanito",
  "block.minecraft.polished_granite_stairs": "Ixkalera ta ch'ulbil karanito",
  "block.minecraft.polished_tuff": "Ch'ulbil tova",
  "block.minecraft.polished_tuff_slab": "Losa ta ch'ulbil tova",
  "block.minecraft.polished_tuff_stairs": "Ixkalera ta ch'ulbil tova",
  "block.minecraft.polished_tuff_wall": "Muro ta ch'ulbil tova",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Isak'etik",
  "block.minecraft.potted_acacia_sapling": "Maseta xchi'uk k'elom akasia",
  "block.minecraft.potted_allium": "Maseta xchi'uk tuixnichim",
  "block.minecraft.potted_azalea_bush": "Maseta xchi'uk asalea",
  "block.minecraft.potted_azure_bluet": "Maseta xchi'uk sakpak'an nichim",
  "block.minecraft.potted_bamboo": "Maseta xchi'uk ton-aj",
  "block.minecraft.potted_birch_sapling": "Maseta xchi'uk k'elom averul",
  "block.minecraft.potted_blue_orchid": "Maseta xchi'uk yaxal ech'",
  "block.minecraft.potted_brown_mushroom": "Maseta xchi'uk k'anch'etan moni'",
  "block.minecraft.potted_cactus": "Maseta xchi'uk k'anch'etan petok",
  "block.minecraft.potted_cherry_sapling": "Maseta xchi'uk k'elom ch'ixtot",
  "block.minecraft.potted_closed_eyeblossom": "Maseta xchi'uk makal satilal nichim",
  "block.minecraft.potted_cornflower": "Maseta xchi'uk asiano",
  "block.minecraft.potted_crimson_fungus": "Maseta xchi'uk Nether moni'",
  "block.minecraft.potted_crimson_roots": "Maseta xchi'uk tsaja ibeletik",
  "block.minecraft.potted_dandelion": "Maseta xchi'uk amarkon",
  "block.minecraft.potted_dark_oak_sapling": "Maseta xchi'uk k'elom ik'pulan tulan",
  "block.minecraft.potted_dead_bush": "Maseta xchi'uk takin xk'ib",
  "block.minecraft.potted_fern": "Maseta xchi'uk tsib",
  "block.minecraft.potted_flowering_azalea_bush": "Maseta xchi'uk nichimajem alasea",
  "block.minecraft.potted_golden_dandelion": "Maseta xchi'uk yoroal amarkon",
  "block.minecraft.potted_jungle_sapling": "Maseta xchi'uk jabnaltikal k'elom",
  "block.minecraft.potted_lily_of_the_valley": "Maseta xchi'uk yoy ta soplej",
  "block.minecraft.potted_mangrove_propagule": "Maseta xchi'uk poropakulo ja'alte'",
  "block.minecraft.potted_oak_sapling": "Maseta xchi'uk k'elom tulan",
  "block.minecraft.potted_open_eyeblossom": "Maseta xchi'uk jamal satilal nichim",
  "block.minecraft.potted_orange_tulip": "Maseta xchi'uk k'onk'ontik tulipan",
  "block.minecraft.potted_oxeye_daisy": "Maseta xchi'uk markarita",
  "block.minecraft.potted_pale_oak_sapling": "Maseta xchi'uk k'elom sakpak'an tulan",
  "block.minecraft.potted_pink_tulip": "Maseta xchi'uk tsojtsojtik tulipan",
  "block.minecraft.potted_poppy": "Maseta xchi'uk amapola",
  "block.minecraft.potted_red_mushroom": "Maseta xchi'uk tsajal moni'",
  "block.minecraft.potted_red_tulip": "Maseta xchi'uk tsajal tulipan",
  "block.minecraft.potted_spruce_sapling": "Maseta xchi'uk k'elom toj",
  "block.minecraft.potted_torchflower": "Maseta xchi'uk nop'olnichim",
  "block.minecraft.potted_warped_fungus": "Maseta xchi'uk ts'otol moni'",
  "block.minecraft.potted_warped_roots": "Maseta xchi'uk ts'otol ibeletik",
  "block.minecraft.potted_white_tulip": "Maseta xchi'uk sakil tulipan",
  "block.minecraft.potted_wither_rose": "Maseta xchi'uk xroxa Wither",
  "block.minecraft.powder_snow": "P'up' taiv",
  "block.minecraft.powder_snow_cauldron": "Kaltera xchi'uk p'up' taiv",
  "block.minecraft.powered_rail": "Xanebal yuk'lajetel",
  "block.minecraft.prismarine": "Pirismarina",
  "block.minecraft.prismarine_brick_slab": "Losa ta latriyoetik ta pirismarina",
  "block.minecraft.prismarine_brick_stairs": "Ixkalera ta latriyo ta pirismarina",
  "block.minecraft.prismarine_bricks": "Latriyoetik ta pirismarina",
  "block.minecraft.prismarine_slab": "Losa ta pirismarina",
  "block.minecraft.prismarine_stairs": "Ixkalera ta pirismarina",
  "block.minecraft.prismarine_wall": "Muro ta pirismarina",
  "block.minecraft.pumpkin": "Ch'um",
  "block.minecraft.pumpkin_stem": "Ch'ut ch'um",
  "block.minecraft.purple_banner": "Ik'pok'an vantera",
  "block.minecraft.purple_bed": "Ik'pok'an tem",
  "block.minecraft.purple_candle": "Ik'pok'an kantela",
  "block.minecraft.purple_candle_cake": "Pastel xchi'uk ik'pok'an kantela",
  "block.minecraft.purple_carpet": "Ik'pok'an tapete",
  "block.minecraft.purple_concrete": "Ik'pok'an konkereto",
  "block.minecraft.purple_concrete_powder": "Ik'pok'an semento",
  "block.minecraft.purple_glazed_terracotta": "Ik'pok'an asulejo",
  "block.minecraft.purple_shulker_box": "Ik'pok'an kaxa yu'un shulker",
  "block.minecraft.purple_stained_glass": "Ik'pok'an nen",
  "block.minecraft.purple_stained_glass_pane": "Ik'pok'an panel ta nen",
  "block.minecraft.purple_terracotta": "Ik'pok'an lakal ach'el",
  "block.minecraft.purple_wool": "Ik'pok'an tsots",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Oy purpur",
  "block.minecraft.purpur_slab": "Losa ta purpur",
  "block.minecraft.purpur_stairs": "Ixkalera ta purpur",
  "block.minecraft.quartz_block": "Kubo ta kuarso",
  "block.minecraft.quartz_bricks": "Latriyoetik ta kuarso",
  "block.minecraft.quartz_pillar": "Oy ta kuarso",
  "block.minecraft.quartz_slab": "Losa ta kuarso",
  "block.minecraft.quartz_stairs": "Ixkalera ta kuarso",
  "block.minecraft.rail": "Xanebal",
  "block.minecraft.raw_copper_block": "Kubo ta lumil k'anal k'unil tak'in",
  "block.minecraft.raw_gold_block": "Kubo ta lumil k'anal tak'in",
  "block.minecraft.raw_iron_block": "Kubo ta lumil tak'in",
  "block.minecraft.red_banner": "Tsajal vantera",
  "block.minecraft.red_bed": "Tsajal tem",
  "block.minecraft.red_candle": "Tsajal kantela",
  "block.minecraft.red_candle_cake": "Pastel xchi'uk tsajal kantela",
  "block.minecraft.red_carpet": "Tsajal tapete",
  "block.minecraft.red_concrete": "Tsajal konkereto",
  "block.minecraft.red_concrete_powder": "Tsajal semento",
  "block.minecraft.red_glazed_terracotta": "Tsajal asulejo",
  "block.minecraft.red_mushroom": "Tsajal moni'",
  "block.minecraft.red_mushroom_block": "Kubo ta tsajal moni'",
  "block.minecraft.red_nether_brick_slab": "Losa ta tsajal Nether latriyoetik",
  "block.minecraft.red_nether_brick_stairs": "Ixkalera ta tsajal Nether latriyoetik",
  "block.minecraft.red_nether_brick_wall": "Muro ta tsajal Nether latriyoetik",
  "block.minecraft.red_nether_bricks": "Tsajal Nether latriyoetik",
  "block.minecraft.red_sand": "Tsajal yi'",
  "block.minecraft.red_sandstone": "Tsajal areniska",
  "block.minecraft.red_sandstone_slab": "Losa ta tsajal areniska",
  "block.minecraft.red_sandstone_stairs": "Ixkalera ta tsajal areniska",
  "block.minecraft.red_sandstone_wall": "Muro ta tsajal areniska",
  "block.minecraft.red_shulker_box": "Tsajal kaxa yu'un shulker",
  "block.minecraft.red_stained_glass": "Tsajal nen",
  "block.minecraft.red_stained_glass_pane": "Tsajal panel ta nen",
  "block.minecraft.red_terracotta": "Tsajal lakal ach'el",
  "block.minecraft.red_tulip": "Tsajal tulipan",
  "block.minecraft.red_wool": "Tsajal tsots",
  "block.minecraft.redstone_block": "Kubo ta redstone",
  "block.minecraft.redstone_lamp": "Lampara redstone",
  "block.minecraft.redstone_ore": "Mineral redstone",
  "block.minecraft.redstone_torch": "Jch'ob toj ta redstone",
  "block.minecraft.redstone_wall_torch": "Jch'ob toj ta redstone ta kubo",
  "block.minecraft.redstone_wire": "Alampre ta redstone",
  "block.minecraft.reinforced_deepslate": "Tsatsubtasbil ik'pulanton",
  "block.minecraft.repeater": "Cha'pasobil ta redstone",
  "block.minecraft.repeating_command_block": "Kubo mantal cha'pasel",
  "block.minecraft.resin_block": "Kubo ta xuch'",
  "block.minecraft.resin_brick_slab": "Losa ta latriyoetik ta xuch'",
  "block.minecraft.resin_brick_stairs": "Ixkalera ta latriyoetik ta xuch'",
  "block.minecraft.resin_brick_wall": "Muro ta latriyoetik ta xuchꞌ",
  "block.minecraft.resin_bricks": "Latriyoetik ta xuchꞌ",
  "block.minecraft.resin_clump": "Xuch'",
  "block.minecraft.respawn_anchor": "Cha'vinajebal",
  "block.minecraft.rooted_dirt": "Tek'tsajesbil lum",
  "block.minecraft.rose_bush": "Roxa",
  "block.minecraft.sand": "Yi'",
  "block.minecraft.sandstone": "Areniska",
  "block.minecraft.sandstone_slab": "Losa ta areniska",
  "block.minecraft.sandstone_stairs": "Ixkalera ta areniska",
  "block.minecraft.sandstone_wall": "Muro ta areniska",
  "block.minecraft.scaffolding": "Antamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Spasob-kanalisar sculk",
  "block.minecraft.sculk_sensor": "A'iob-sculk",
  "block.minecraft.sculk_shrieker": "Ok'obil ta sculk",
  "block.minecraft.sculk_vein": "Lok'el-sculk",
  "block.minecraft.sea_lantern": "Nabal joko",
  "block.minecraft.sea_pickle": "Nabal pepino",
  "block.minecraft.seagrass": "Nabal yaxal",
  "block.minecraft.set_spawn": "Cha'vinajebal ak'bil",
  "block.minecraft.short_dry_grass": "Komkom takin yaxal",
  "block.minecraft.short_grass": "Komkom yaxal",
  "block.minecraft.shroomlight": "Nop'olmoni'",
  "block.minecraft.shulker_box": "Kaxa yu'un shulker",
  "block.minecraft.skeleton_skull": "Sbakil sjol jbakubel",
  "block.minecraft.skeleton_wall_skull": "Sbakil sjol jbakubel ta kubo",
  "block.minecraft.slime_block": "Kubo simil",
  "block.minecraft.small_amethyst_bud": "Bik'it lok'el amatista",
  "block.minecraft.small_dripleaf": "Bik'it toyte'",
  "block.minecraft.smithing_table": "Mexa ta tak'inal",
  "block.minecraft.smoker": "Ch'ataobil",
  "block.minecraft.smooth_basalt": "Ch'ulul vasalto",
  "block.minecraft.smooth_quartz": "Kubo ta ch'ulul kuarso",
  "block.minecraft.smooth_quartz_slab": "Losa ta ch'ulul kuarso",
  "block.minecraft.smooth_quartz_stairs": "Ixkalera ta ch'ulul kuarso",
  "block.minecraft.smooth_red_sandstone": "Ch'ulul tsajal areniska",
  "block.minecraft.smooth_red_sandstone_slab": "Losa ta ch'ulul tsajal areniska",
  "block.minecraft.smooth_red_sandstone_stairs": "Ixkalera ta ch'ulul tsajal areniska",
  "block.minecraft.smooth_sandstone": "Ch'ulul areniska",
  "block.minecraft.smooth_sandstone_slab": "Losa ta ch'ulul areniska",
  "block.minecraft.smooth_sandstone_stairs": "Ixkalera ta ch'ulul areniska",
  "block.minecraft.smooth_stone": "Ch'ulul ton",
  "block.minecraft.smooth_stone_slab": "Losa ta ch'ulul ton",
  "block.minecraft.sniffer_egg": "Ton j-uts'ivanej",
  "block.minecraft.snow": "Taiv",
  "block.minecraft.snow_block": "Kubo ta taiv",
  "block.minecraft.soul_campfire": "K'ok' ch'ulelal",
  "block.minecraft.soul_fire": "K'ok' ch'ulelal",
  "block.minecraft.soul_lantern": "Joko ch'ulelal",
  "block.minecraft.soul_sand": "Yi' ch'ulelal",
  "block.minecraft.soul_soil": "Lum ch'ulelal",
  "block.minecraft.soul_torch": "Jch'ob toj ta ch'ulelal",
  "block.minecraft.soul_wall_torch": "Jch'ob toj ta ch'ulelal ta kubo",
  "block.minecraft.spawn.not_valid": "Mu'yuk atem o mu nojem li acha'vinajebe, o ja' makal",
  "block.minecraft.spawner": "Vinajesob monstro",
  "block.minecraft.spawner.desc1": "Tuneso jbej vinajesobil:",
  "block.minecraft.spawner.desc2": "Chak' li tos chanule",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Espora nichim",
  "block.minecraft.spruce_button": "Voton ta toj",
  "block.minecraft.spruce_door": "Ti'na ta toj",
  "block.minecraft.spruce_fence": "Mok ta toj",
  "block.minecraft.spruce_fence_gate": "Ti' mok ta toj",
  "block.minecraft.spruce_hanging_sign": "Jipiej leterero ta toj",
  "block.minecraft.spruce_leaves": "Yanaltak toj",
  "block.minecraft.spruce_log": "Chumante'el toj",
  "block.minecraft.spruce_planks": "Tenelte'etik ta toj",
  "block.minecraft.spruce_pressure_plate": "Net'obil ta toj",
  "block.minecraft.spruce_sapling": "K'elom toj",
  "block.minecraft.spruce_shelf": "Repisa ta toj",
  "block.minecraft.spruce_sign": "Leterero ta toj",
  "block.minecraft.spruce_slab": "Losa ta toj",
  "block.minecraft.spruce_stairs": "Ixkalera ta toj",
  "block.minecraft.spruce_trapdoor": "Ti' pets' ta toj",
  "block.minecraft.spruce_wall_hanging_sign": "Jipiej leterero ta toj ta kubo",
  "block.minecraft.spruce_wall_sign": "Leterero ta toj ta kubo",
  "block.minecraft.spruce_wood": "Toj te'",
  "block.minecraft.sticky_piston": "Noch'och' piston",
  "block.minecraft.stone": "Ton",
  "block.minecraft.stone_brick_slab": "Losa ta latriyoetik ta ton",
  "block.minecraft.stone_brick_stairs": "Ixkalera ta latriyoetik ta ton",
  "block.minecraft.stone_brick_wall": "Muro ta latriyoetik ta ton",
  "block.minecraft.stone_bricks": "Latriyoetik ta ton",
  "block.minecraft.stone_button": "Voton ta ton",
  "block.minecraft.stone_pressure_plate": "Net'obil ta ton",
  "block.minecraft.stone_slab": "Losa ta ton",
  "block.minecraft.stone_stairs": "Ixkalera ta ton",
  "block.minecraft.stonecutter": "Javton",
  "block.minecraft.stripped_acacia_log": "Chumante' akasia mu xchi'uk spat",
  "block.minecraft.stripped_acacia_wood": "Akasia te' mu xchi'uk spat",
  "block.minecraft.stripped_bamboo_block": "Kubo ta ton-aj mu xchi'uk spat",
  "block.minecraft.stripped_birch_log": "Chumante' averul mu xchi'uk spat",
  "block.minecraft.stripped_birch_wood": "Averul te' mu xchi'uk spat",
  "block.minecraft.stripped_cherry_log": "Chumante' ch'ixtot mu xchi'uk spat",
  "block.minecraft.stripped_cherry_wood": "Ch'ixtot te' mu xchi'uk spat",
  "block.minecraft.stripped_crimson_hyphae": "Tsajal ipax mu xchi'uk spat",
  "block.minecraft.stripped_crimson_stem": "Tsajal ch'util mu xchi'uk spat",
  "block.minecraft.stripped_dark_oak_log": "Chumante' ik'pulan tulan mu xchi'uk spat",
  "block.minecraft.stripped_dark_oak_wood": "Ik'pulan tulan te' mu xchi'uk spat",
  "block.minecraft.stripped_jungle_log": "Jabnaltikal chumante' mu xchi'uk spat",
  "block.minecraft.stripped_jungle_wood": "Jabnaltikal te' mu xchi'uk spat",
  "block.minecraft.stripped_mangrove_log": "Chumante' ja'alte' mu xchi'uk spat",
  "block.minecraft.stripped_mangrove_wood": "Ja'alte' mu xchi'uk spat",
  "block.minecraft.stripped_oak_log": "Chumante' tulan mu xchi'uk spat",
  "block.minecraft.stripped_oak_wood": "Tulan te' mu xchi'uk spat",
  "block.minecraft.stripped_pale_oak_log": "Chumante' sakpak'an tulan mu xchi'uk spat",
  "block.minecraft.stripped_pale_oak_wood": "Sakpak'an tulan te' mu xchi'uk spat",
  "block.minecraft.stripped_spruce_log": "Toj te' mu xchi'uk spat",
  "block.minecraft.stripped_spruce_wood": "Toj te' mu xchi'uk spat",
  "block.minecraft.stripped_warped_hyphae": "Ts'otol ipax mu xchi'uk spat",
  "block.minecraft.stripped_warped_stem": "Ts'otol ch'util mu xchi'uk spat",
  "block.minecraft.structure_block": "Kubo ta meltsajel",
  "block.minecraft.structure_void": "Pojolal meltsajel",
  "block.minecraft.sugar_cane": "Vale'",
  "block.minecraft.sunflower": "Sun",
  "block.minecraft.suspicious_gravel": "Chopol xixibton",
  "block.minecraft.suspicious_sand": "Chopol yi'",
  "block.minecraft.sweet_berry_bush": "Te'elbaya",
  "block.minecraft.tall_dry_grass": "Natil takin yaxal",
  "block.minecraft.tall_grass": "Natil yaxal",
  "block.minecraft.tall_seagrass": "Natil nabal yaxal",
  "block.minecraft.target": "Riana",
  "block.minecraft.terracotta": "Lakal ach'el",
  "block.minecraft.test_block": "Kubo preva",
  "block.minecraft.test_instance_block": "Kubo ta yilobil preva",
  "block.minecraft.tinted_glass": "Ik'pulan nen",
  "block.minecraft.tnt": "Rinamita",
  "block.minecraft.tnt.disabled": "Tubbilik li t'omesrinamitaetike",
  "block.minecraft.torch": "Jch'ob toj",
  "block.minecraft.torchflower": "Nop'olnichim",
  "block.minecraft.torchflower_crop": "Ts'un nop'olnichim",
  "block.minecraft.trapped_chest": "Kaxa pets'",
  "block.minecraft.trial_spawner": "Vinajesob tsatsalil",
  "block.minecraft.tripwire": "No ta tsanel",
  "block.minecraft.tripwire_hook": "Kancho no",
  "block.minecraft.tube_coral": "Tubo nabalte'",
  "block.minecraft.tube_coral_block": "Kubo tubo nabalte'",
  "block.minecraft.tube_coral_fan": "Tubo korkonia",
  "block.minecraft.tube_coral_wall_fan": "Tubo korkonia ta kubo",
  "block.minecraft.tuff": "Tova",
  "block.minecraft.tuff_brick_slab": "Losa ta latriyoetik ta tova",
  "block.minecraft.tuff_brick_stairs": "Ixkalera ta latriyoetik ta tova",
  "block.minecraft.tuff_brick_wall": "Muro ta latriyoetik ta tova",
  "block.minecraft.tuff_bricks": "Latriyoetik ta tova",
  "block.minecraft.tuff_slab": "Losa ta tova",
  "block.minecraft.tuff_stairs": "Ixkalera ta tova",
  "block.minecraft.tuff_wall": "Muro ta tova",
  "block.minecraft.turtle_egg": "Ton ok",
  "block.minecraft.twisting_vines": "Ts'otol ak'etik",
  "block.minecraft.twisting_vines_plant": "Ts'otol ak'",
  "block.minecraft.vault": "Arkon",
  "block.minecraft.verdant_froglight": "Yaxal nop'olkubo",
  "block.minecraft.vine": "Ak'etik",
  "block.minecraft.void_air": "Yik' pojolal",
  "block.minecraft.wall_torch": "Jch'ob toj ta kubo",
  "block.minecraft.warped_button": "Lukluk voton",
  "block.minecraft.warped_door": "Lukluk ti'na",
  "block.minecraft.warped_fence": "Lukluk mok",
  "block.minecraft.warped_fence_gate": "Lukluk ti' mok",
  "block.minecraft.warped_fungus": "Ts'otol moni'",
  "block.minecraft.warped_hanging_sign": "Lukluk jipiej leterero",
  "block.minecraft.warped_hyphae": "Ts'otol ipaxetik",
  "block.minecraft.warped_nylium": "Ts'otol nilio",
  "block.minecraft.warped_planks": "Lukluk tenelte'etik",
  "block.minecraft.warped_pressure_plate": "Lukluk net'obil",
  "block.minecraft.warped_roots": "Ts'otol ibeletik",
  "block.minecraft.warped_shelf": "Ts'otol repisa",
  "block.minecraft.warped_sign": "Lukluk leterero",
  "block.minecraft.warped_slab": "Lukluk losa",
  "block.minecraft.warped_stairs": "Lukluk ixkalera",
  "block.minecraft.warped_stem": "Ts'otol ch'util",
  "block.minecraft.warped_trapdoor": "Lukluk ti' pets'",
  "block.minecraft.warped_wall_hanging_sign": "Lukluk jipiej leterero ta kubo",
  "block.minecraft.warped_wall_sign": "Lukluk leterero ta kubo",
  "block.minecraft.warped_wart_block": "Kubo ta ts'otol ch'okte'",
  "block.minecraft.water": "Vo'",
  "block.minecraft.water_cauldron": "Kaltera xchi'uk vo'",
  "block.minecraft.waxed_chiseled_copper": "Chabtabil lok'tabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_bars": "Baraetik ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_block": "Chabtabil kubo ta k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_bulb": "Joko ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_chain": "Karena ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_chest": "Kaxa ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_door": "Ti'na ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_golem_statue": "Eskultura ta jchabivanej ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_grate": "Rejiya ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_lantern": "Joko ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_copper_trapdoor": "Ti' pets' ta chabtabil k'anal k'unil tak'in",
  "block.minecraft.waxed_cut_copper": "Chabtabil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_cut_copper_slab": "Losa ta chabtabil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_cut_copper_stairs": "Ixkalera tq chabtabil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_chiseled_copper": "Chabtabil k'oxetajesbil lok'tabil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper": "Chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_bars": "Baraetik ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_bulb": "Joko ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_chain": "Karena ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_chest": "Kaxa ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_door": "Ti'na ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Eskultura ta jchabivanej ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_grate": "Rejiya ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_lantern": "Joko ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ti' pets' ta chabtabil k'oxetajesbil k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_cut_copper": "Chabtabil k'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Losa ta chabtabil k'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ixkalera ta chabtabil k'oxetajesbil mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_exposed_lightning_rod": "Chabtabil k'oxetajesbil yikob anjel",
  "block.minecraft.waxed_lightning_rod": "Chabtabil yikob anjel",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Chabtabil kux lok'tabil k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper": "Chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_bars": "Baraetik ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_bulb": "Joko ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_chain": "Karena ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_chest": "Kaxa ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_door": "Ti'na ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Eskultura ta jchabivanej ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_grate": "Rejiya ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_lantern": "Joko ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ti' pets' ta chabtabil kux k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_cut_copper": "Chabtabil kux mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Losa ta chabtabil kux mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ixkalera ta chabtabil kux mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_oxidized_lightning_rod": "Chabtabil kux yikob anjel",
  "block.minecraft.waxed_weathered_chiseled_copper": "Chabtabil sokem lok'tabil k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper": "Chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_bars": "Baraetik ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_bulb": "Joko ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_chain": "Karena ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_chest": "Kaxa ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_door": "Ti'na ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Eskultura ta jchabivanej ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_grate": "Rejiya ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_lantern": "Joko ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ti' pets' ta chabtabil sokem k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_cut_copper": "Chabtabil sokem mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Losa ta chabtabil sokem mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ixkalera ta chabtabil sokem mokol k'anal k'unil tak'in",
  "block.minecraft.waxed_weathered_lightning_rod": "Chabtabil sokem yikob anjel",
  "block.minecraft.weathered_chiseled_copper": "Sokem lok'tabil k'anal k'unil tak'in",
  "block.minecraft.weathered_copper": "Sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_bars": "Baraetik ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_bulb": "Joko ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_chain": "Karena ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_chest": "Kaxa ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_door": "Ti'na ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_golem_statue": "Eskultura ta jchabivanej ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_grate": "Rejiya ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_lantern": "Joko ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_copper_trapdoor": "Ti' pets' ta sokem k'anal k'unil tak'in",
  "block.minecraft.weathered_cut_copper": "Sokem mokol k'anal k'unil tak'in",
  "block.minecraft.weathered_cut_copper_slab": "Losa ta sokem mokol k'anal k'unil tak'in",
  "block.minecraft.weathered_cut_copper_stairs": "Ixkalera ta sokem mokol k'anal k'unil tak'in",
  "block.minecraft.weathered_lightning_rod": "Sokem yikob anjel",
  "block.minecraft.weeping_vines": "J-ok'el ak'etik",
  "block.minecraft.weeping_vines_plant": "J-ok'el ak'",
  "block.minecraft.wet_sponge": "Losol esponja",
  "block.minecraft.wheat": "Ts'un kaxlan ixim",
  "block.minecraft.white_banner": "Sakil vantera",
  "block.minecraft.white_bed": "Sakil tem",
  "block.minecraft.white_candle": "Sakil kantela",
  "block.minecraft.white_candle_cake": "Pastel xchi'uk sakil kantela",
  "block.minecraft.white_carpet": "Sakil tapete",
  "block.minecraft.white_concrete": "Sakil konkereto",
  "block.minecraft.white_concrete_powder": "Sakil semento",
  "block.minecraft.white_glazed_terracotta": "Sakil asulejo",
  "block.minecraft.white_shulker_box": "Sakil kaxa yu'un shulker",
  "block.minecraft.white_stained_glass": "Sakil nen",
  "block.minecraft.white_stained_glass_pane": "Sakil panel ta nen",
  "block.minecraft.white_terracotta": "Sakil lakal ach'el",
  "block.minecraft.white_tulip": "Sakil tulipan",
  "block.minecraft.white_wool": "Sakil tsots",
  "block.minecraft.wildflowers": "Te'tikal nichimetik",
  "block.minecraft.wither_rose": "Xroxa Wither",
  "block.minecraft.wither_skeleton_skull": "Sbakil sjol Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Sbakil sjol Wither ta kubo",
  "block.minecraft.yellow_banner": "K'anal vantera",
  "block.minecraft.yellow_bed": "K'anal tem",
  "block.minecraft.yellow_candle": "K'anal kantela",
  "block.minecraft.yellow_candle_cake": "Pastel xchi'uk k'anal kantela",
  "block.minecraft.yellow_carpet": "K'anal tapete",
  "block.minecraft.yellow_concrete": "K'anal konkereto",
  "block.minecraft.yellow_concrete_powder": "K'anal semento",
  "block.minecraft.yellow_glazed_terracotta": "K'anal asulejo",
  "block.minecraft.yellow_shulker_box": "K'anal kaxa yu'un shulker",
  "block.minecraft.yellow_stained_glass": "K'anal nen",
  "block.minecraft.yellow_stained_glass_pane": "K'anal panel nen",
  "block.minecraft.yellow_terracotta": "K'anal lakal ach'el",
  "block.minecraft.yellow_wool": "K'anal tsots",
  "block.minecraft.zombie_head": "Sjol jchamel",
  "block.minecraft.zombie_wall_head": "Sjol jchamel ta kubo",
  "item.minecraft.acacia_boat": "Varko akasia",
  "item.minecraft.acacia_chest_boat": "Varko akasia xchi'uk kaxa",
  "item.minecraft.allay_spawn_egg": "Vinajesob jkoltaobbail",
  "item.minecraft.amethyst_shard": "Xut amatista",
  "item.minecraft.angler_pottery_shard": "Xut seramika jtsakchoy",
  "item.minecraft.angler_pottery_sherd": "Xut seramika jtsakchoy",
  "item.minecraft.apple": "Mantsana",
  "item.minecraft.archer_pottery_shard": "Xut seramika j-alkol",
  "item.minecraft.archer_pottery_sherd": "Xut seramika j-alkol",
  "item.minecraft.armadillo_scute": "Smik'al ib",
  "item.minecraft.armadillo_spawn_egg": "Vinajesob ib",
  "item.minecraft.armor_stand": "Kuchob almarura",
  "item.minecraft.arms_up_pottery_shard": "Xut seramika axinal",
  "item.minecraft.arms_up_pottery_sherd": "Xut seramika axinal",
  "item.minecraft.arrow": "Yolob",
  "item.minecraft.axolotl_bucket": "Valte xchi'uk axolote",
  "item.minecraft.axolotl_spawn_egg": "Vinajesob axolote",
  "item.minecraft.baked_potato": "Pusiltasbil isak'",
  "item.minecraft.bamboo_chest_raft": "Valsa xchi'uk kaxa",
  "item.minecraft.bamboo_raft": "Valsa",
  "item.minecraft.bat_spawn_egg": "Vinajesob sots'",
  "item.minecraft.bee_spawn_egg": "Vinajesob xchanul pom",
  "item.minecraft.beef": "Tse bek'tal vakax",
  "item.minecraft.beetroot": "Aselka",
  "item.minecraft.beetroot_seeds": "Yi'beltak aselka",
  "item.minecraft.beetroot_soup": "Sopa aselka",
  "item.minecraft.birch_boat": "Varko averul",
  "item.minecraft.birch_chest_boat": "Varko averul xchi'uk kaxa",
  "item.minecraft.black_bundle": "Ik'al moral",
  "item.minecraft.black_dye": "Ik'al bonolil",
  "item.minecraft.black_harness": "Ik'al pek'",
  "item.minecraft.blade_pottery_shard": "Xut seramika espara",
  "item.minecraft.blade_pottery_sherd": "Xut seramika espara",
  "item.minecraft.blaze_powder": "Ts'ub jk'ok'",
  "item.minecraft.blaze_rod": "Te'el jk'ok'",
  "item.minecraft.blaze_spawn_egg": "Vinajesob jk'ok'",
  "item.minecraft.blue_bundle": "Yaxal moral",
  "item.minecraft.blue_dye": "Yaxal bonolil",
  "item.minecraft.blue_egg": "Yaxal ton alak'",
  "item.minecraft.blue_harness": "Yaxal pek'",
  "item.minecraft.bogged_spawn_egg": "Vinajesob j-ach'el",
  "item.minecraft.bolt_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornamento anjel",
  "item.minecraft.bone": "Bakelil",
  "item.minecraft.bone_meal": "Ts'ub bakelil",
  "item.minecraft.book": "Vun",
  "item.minecraft.bordure_indented_banner_pattern": "Lok'tael ta tanal-eal ti'il",
  "item.minecraft.bow": "Alkol",
  "item.minecraft.bowl": "Tason",
  "item.minecraft.bread": "Kaxlan vaj",
  "item.minecraft.breeze_rod": "Te'el j-ik'",
  "item.minecraft.breeze_spawn_egg": "Vinajesob j-ik'",
  "item.minecraft.brewer_pottery_shard": "Xut seramika poxil",
  "item.minecraft.brewer_pottery_sherd": "Xut seramika poxil",
  "item.minecraft.brewing_stand": "Chijobil",
  "item.minecraft.brick": "Latriyo",
  "item.minecraft.brown_bundle": "K'anch'etan moral",
  "item.minecraft.brown_dye": "K'anch'etan bonolil",
  "item.minecraft.brown_egg": "K'anch'etan ton alak'",
  "item.minecraft.brown_harness": "K'anch'etan pek'",
  "item.minecraft.brush": "Ch'ulobil",
  "item.minecraft.bucket": "Valte",
  "item.minecraft.bundle": "Moral",
  "item.minecraft.bundle.empty": "Pojol",
  "item.minecraft.bundle.empty.description": "Xu' skuch jun jelbil tsobol ta k'usitik",
  "item.minecraft.bundle.full": "Nojol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Xut seramika k'ok'",
  "item.minecraft.burn_pottery_sherd": "Xut seramika k'ok'",
  "item.minecraft.camel_husk_spawn_egg": "Vinajesob ulem toromerario",
  "item.minecraft.camel_spawn_egg": "Vinajesob toromerario",
  "item.minecraft.carrot": "Sanaoria",
  "item.minecraft.carrot_on_a_stick": "Te' xchi'uk sanaoria",
  "item.minecraft.cat_spawn_egg": "Vinajesob sup",
  "item.minecraft.cauldron": "Kaltera",
  "item.minecraft.cave_spider_spawn_egg": "Vinajesob ch'enal om",
  "item.minecraft.chainmail_boots": "Xonob nuti'tak'inetik",
  "item.minecraft.chainmail_chestplate": "Korasa nuti'tak'in",
  "item.minecraft.chainmail_helmet": "Yelma nuti'tak'in",
  "item.minecraft.chainmail_leggings": "Vex nuti'tak'in",
  "item.minecraft.charcoal": "Ak'al",
  "item.minecraft.cherry_boat": "Varko ch'ixtot",
  "item.minecraft.cherry_chest_boat": "Varko ch'ixtot xchi'uk kaxa",
  "item.minecraft.chest_minecart": "Vakon xchi'uk kaxa",
  "item.minecraft.chicken": "Tse bek'tal alak'",
  "item.minecraft.chicken_spawn_egg": "Vinajesob alak'",
  "item.minecraft.chorus_fruit": "Chorus sat-te'",
  "item.minecraft.clay_ball": "Lumil bola",
  "item.minecraft.clock": "K'elob-ora",
  "item.minecraft.coal": "Ak'al",
  "item.minecraft.coast_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornamento ti'il",
  "item.minecraft.cocoa_beans": "Kokov",
  "item.minecraft.cod": "Tse bek'tal vakalao",
  "item.minecraft.cod_bucket": "Valte xchi'uk vakalao",
  "item.minecraft.cod_spawn_egg": "Vinajesob vakalao",
  "item.minecraft.command_block_minecart": "Vakon xchi'uk kubo mantal",
  "item.minecraft.compass": "Burujula",
  "item.minecraft.cooked_beef": "Vobil bek'et",
  "item.minecraft.cooked_chicken": "Vobil bek'tal alak'",
  "item.minecraft.cooked_cod": "Vobil bek'tal vakalao",
  "item.minecraft.cooked_mutton": "Vobil bek'tal chij",
  "item.minecraft.cooked_porkchop": "Vobil bek'tal chitom",
  "item.minecraft.cooked_rabbit": "Vobil bek'tal t'ul",
  "item.minecraft.cooked_salmon": "Vobil bek'tal xalmon",
  "item.minecraft.cookie": "Kayeta",
  "item.minecraft.copper_axe": "Ek'el k'anal k'unil tak'in",
  "item.minecraft.copper_boots": "Xonob k'anal k'unil tak'in",
  "item.minecraft.copper_chestplate": "Korasa k'anal k'unil tak'in",
  "item.minecraft.copper_golem_spawn_egg": "Vinajesob jchabivanej k'anal k'unil tak'in",
  "item.minecraft.copper_helmet": "Kasko k'anal k'unil tak'in",
  "item.minecraft.copper_hoe": "Asaron k'anal k'unil tak'in",
  "item.minecraft.copper_horse_armor": "Almarura k'anal k'unil tak'in sventa ka'",
  "item.minecraft.copper_ingot": "Linkote k'anal k'unil tak'in",
  "item.minecraft.copper_leggings": "Vex k'anal k'unil tak'in",
  "item.minecraft.copper_nautilus_armor": "Amarura k'anal k'unil tak'in sventa navtilo",
  "item.minecraft.copper_nugget": "Bek' k'anal k'unil tak'in",
  "item.minecraft.copper_pickaxe": "Piko k'anal k'unil tak'in",
  "item.minecraft.copper_shovel": "Pala k'unil k'anal tak'in",
  "item.minecraft.copper_spear": "Lansa k'anal k'unil tak'in",
  "item.minecraft.copper_sword": "Espara k'anal k'unil tak'in",
  "item.minecraft.cow_spawn_egg": "Vinajesob vakax",
  "item.minecraft.creaking_spawn_egg": "Vinajesob jch'ak'ak'etajel",
  "item.minecraft.creeper_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Lok'tael ta creeper",
  "item.minecraft.creeper_spawn_egg": "Vinajesob creeper",
  "item.minecraft.crossbow": "Alkoltak'in",
  "item.minecraft.crossbow.projectile": "Vala:",
  "item.minecraft.crossbow.projectile.multiple": "Vala: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Vala: %s",
  "item.minecraft.cyan_bundle": "Yax-elan moral",
  "item.minecraft.cyan_dye": "Yax-elan bonolil",
  "item.minecraft.cyan_harness": "Yax-elan pek'",
  "item.minecraft.danger_pottery_shard": "Xut seramika xi'el",
  "item.minecraft.danger_pottery_sherd": "Xut seramika xi'el",
  "item.minecraft.dark_oak_boat": "Varko ik'pulan tulan",
  "item.minecraft.dark_oak_chest_boat": "Varko ik'pulan tulan xchi'uk kaxa",
  "item.minecraft.debug_stick": "Te'el kusel",
  "item.minecraft.debug_stick.empty": "Ch'abal yu'unineltak li %se",
  "item.minecraft.debug_stick.select": "la st'uj ''%s'' (%s)",
  "item.minecraft.debug_stick.update": "''%s'' jelat ta %s",
  "item.minecraft.diamond": "Riamante",
  "item.minecraft.diamond_axe": "Ek'el riamante",
  "item.minecraft.diamond_boots": "Xonob riamanteetik",
  "item.minecraft.diamond_chestplate": "Korasa riamante",
  "item.minecraft.diamond_helmet": "Kasko riamante",
  "item.minecraft.diamond_hoe": "Asaron riamante",
  "item.minecraft.diamond_horse_armor": "Almarura riamante sventa ka'",
  "item.minecraft.diamond_leggings": "Vex riamante",
  "item.minecraft.diamond_nautilus_armor": "Armarura riamante sventa navtilo",
  "item.minecraft.diamond_pickaxe": "Piko riamante",
  "item.minecraft.diamond_shovel": "Pala riamante",
  "item.minecraft.diamond_spear": "Lansa riamante",
  "item.minecraft.diamond_sword": "Espara riamante",
  "item.minecraft.disc_fragment_5": "Xut risko",
  "item.minecraft.disc_fragment_5.desc": "Risko: 5",
  "item.minecraft.dolphin_spawn_egg": "Vinajesob telpin",
  "item.minecraft.donkey_spawn_egg": "Vinajesob vuro",
  "item.minecraft.dragon_breath": "Yik' muk'ta ain",
  "item.minecraft.dried_kelp": "Takin alka",
  "item.minecraft.drowned_spawn_egg": "Vinajesob jt'uxijel",
  "item.minecraft.dune_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornamento runa",
  "item.minecraft.echo_shard": "Xut ech'omal",
  "item.minecraft.egg": "Ton alak'",
  "item.minecraft.elder_guardian_spawn_egg": "Vinajesob malal jchabivanej",
  "item.minecraft.elytra": "End-xik'etik",
  "item.minecraft.emerald": "Esmeralta",
  "item.minecraft.enchanted_book": "Kapbil vun",
  "item.minecraft.enchanted_golden_apple": "Kapbil mantsana k'anal tak'in",
  "item.minecraft.end_crystal": "End-kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Vinajesob muk'ta ain",
  "item.minecraft.ender_eye": "Sat ender",
  "item.minecraft.ender_pearl": "Ender perla",
  "item.minecraft.enderman_spawn_egg": "Vinajesob enderman",
  "item.minecraft.endermite_spawn_egg": "Vinajesob endermite",
  "item.minecraft.evoker_spawn_egg": "Vinajesob j-ik'vanej",
  "item.minecraft.experience_bottle": "Limeta xchi'uk kuxlejal",
  "item.minecraft.explorer_pottery_shard": "Xut seramika jxanbal",
  "item.minecraft.explorer_pottery_sherd": "Xut seramika jxanbal",
  "item.minecraft.eye_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornamento satil",
  "item.minecraft.feather": "K'uk'umil",
  "item.minecraft.fermented_spider_eye": "Ts'ajbil sat om",
  "item.minecraft.field_masoned_banner_pattern": "Lok'tael ta latriyoal",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Nojel k'ok'",
  "item.minecraft.firework_rocket": "Sibak yolonk'ok'",
  "item.minecraft.firework_rocket.flight": "Sjalijel vilel:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Sibak yolok'ok'",
  "item.minecraft.firework_star.black": "Ik'al",
  "item.minecraft.firework_star.blue": "Yaxal",
  "item.minecraft.firework_star.brown": "K'anch'etan",
  "item.minecraft.firework_star.custom_color": "Jelbil",
  "item.minecraft.firework_star.cyan": "Yax-elan",
  "item.minecraft.firework_star.fade_to": "Chk'ataj ta",
  "item.minecraft.firework_star.flicker": "Nop'op'etel",
  "item.minecraft.firework_star.gray": "K'anch'etan",
  "item.minecraft.firework_star.green": "Yaxal",
  "item.minecraft.firework_star.light_blue": "Yaxal",
  "item.minecraft.firework_star.light_gray": "K'anch'etan",
  "item.minecraft.firework_star.lime": "Yoxyoxtik",
  "item.minecraft.firework_star.magenta": "Tsojtsojtik",
  "item.minecraft.firework_star.orange": "K'onk'ontik",
  "item.minecraft.firework_star.pink": "Tsojtsojtik",
  "item.minecraft.firework_star.purple": "Ik'pok'an",
  "item.minecraft.firework_star.red": "Tsajal",
  "item.minecraft.firework_star.shape": "Mu ojtikinbil chak k'ucha'al",
  "item.minecraft.firework_star.shape.burst": "T'omel",
  "item.minecraft.firework_star.shape.creeper": "Chak k'ucha'al creper",
  "item.minecraft.firework_star.shape.large_ball": "Muk'ta bola",
  "item.minecraft.firework_star.shape.small_ball": "Bik'it bola",
  "item.minecraft.firework_star.shape.star": "Chak k'ucha'al k'anal",
  "item.minecraft.firework_star.trail": "Av okil",
  "item.minecraft.firework_star.white": "Sakil",
  "item.minecraft.firework_star.yellow": "K'anal",
  "item.minecraft.fishing_rod": "Te'el tsakchoy",
  "item.minecraft.flint": "Suyton",
  "item.minecraft.flint_and_steel": "Jtsanvanej",
  "item.minecraft.flow_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornamento espiral",
  "item.minecraft.flow_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Lok'tael ta espiral",
  "item.minecraft.flow_pottery_sherd": "Xut seramika espiral",
  "item.minecraft.flower_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.flower_banner_pattern.desc": "Nichim",
  "item.minecraft.flower_banner_pattern.new": "Lok'tael ta nichim",
  "item.minecraft.flower_pot": "Maseta",
  "item.minecraft.fox_spawn_egg": "Vinajesob tsajal vet",
  "item.minecraft.friend_pottery_shard": "Xut seramika amikoal",
  "item.minecraft.friend_pottery_sherd": "Xut seramika amikoal",
  "item.minecraft.frog_spawn_egg": "Vinajesob pok'ok'",
  "item.minecraft.furnace_minecart": "Vakon xchi'uk jorno",
  "item.minecraft.ghast_spawn_egg": "Vinajesob ghast",
  "item.minecraft.ghast_tear": "Ya'el sat ghast",
  "item.minecraft.glass_bottle": "Limeta",
  "item.minecraft.glistering_melon_slice": "Nop'ol xet' xancha",
  "item.minecraft.globe_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.globe_banner_pattern.desc": "Balumil",
  "item.minecraft.globe_banner_pattern.new": "Lok'tael ta balumil",
  "item.minecraft.glow_berries": "Nop'ol bayaetik",
  "item.minecraft.glow_ink_sac": "Nop'ol moral tinta",
  "item.minecraft.glow_item_frame": "Nop'ol marko",
  "item.minecraft.glow_squid_spawn_egg": "Vinajesob nop'ol muk'ta ja'al-om",
  "item.minecraft.glowstone_dust": "Ts'ub nop'olton",
  "item.minecraft.goat_horn": "Kachu tentsun",
  "item.minecraft.goat_spawn_egg": "Vinajesob tentsun",
  "item.minecraft.gold_ingot": "Linkote k'anal tak'in",
  "item.minecraft.gold_nugget": "Bek' k'anal tak'in",
  "item.minecraft.golden_apple": "Mantsana k'anal tak'in",
  "item.minecraft.golden_axe": "Ek'el k'anal tak'in",
  "item.minecraft.golden_boots": "Xonob k'anal tak'inetik",
  "item.minecraft.golden_carrot": "Sanaoria k'anal tak'in",
  "item.minecraft.golden_chestplate": "Korasa k'anal tak'in",
  "item.minecraft.golden_helmet": "Kasko k'anal tak'in",
  "item.minecraft.golden_hoe": "Asaron k'anal tak'in",
  "item.minecraft.golden_horse_armor": "Almarura k'anal tak'in sventa ka'",
  "item.minecraft.golden_leggings": "Vex k'anal tak'in",
  "item.minecraft.golden_nautilus_armor": "Amarura k'anal tak'in sventa navtilo",
  "item.minecraft.golden_pickaxe": "Piko k'anal tak'in",
  "item.minecraft.golden_shovel": "Pala k'anal tak'in",
  "item.minecraft.golden_spear": "Lansa k'anal tak'in",
  "item.minecraft.golden_sword": "Espara k'anal tak'in",
  "item.minecraft.gray_bundle": "K'anch'etan moral",
  "item.minecraft.gray_dye": "K'anch'etan bonolil",
  "item.minecraft.gray_harness": "K'anch'etan pek'",
  "item.minecraft.green_bundle": "Yaxal moral",
  "item.minecraft.green_dye": "Yaxal bonolil",
  "item.minecraft.green_harness": "Yaxal pek'",
  "item.minecraft.guardian_spawn_egg": "Vinajesob jchabivanej",
  "item.minecraft.gunpowder": "Sibak",
  "item.minecraft.guster_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.guster_banner_pattern.desc": "Sutub-ik'",
  "item.minecraft.guster_banner_pattern.new": "Lok'tael ta sutub-ik'",
  "item.minecraft.guster_pottery_sherd": "Xut seramika sutub-ik'",
  "item.minecraft.happy_ghast_spawn_egg": "Vinajesob muyubajem ghast",
  "item.minecraft.harness": "Pek'",
  "item.minecraft.heart_of_the_sea": "Yo'onton muk'ta nab",
  "item.minecraft.heart_pottery_shard": "Xut seramika o'ontonal",
  "item.minecraft.heart_pottery_sherd": "Xut seramika o'ontonal",
  "item.minecraft.heartbreak_pottery_shard": "Xut seramika jomol o'ontonal",
  "item.minecraft.heartbreak_pottery_sherd": "Xut seramika jomol o'ontonal",
  "item.minecraft.hoglin_spawn_egg": "Vinajesob hoglin",
  "item.minecraft.honey_bottle": "Limeta xchi'uk ajapom",
  "item.minecraft.honeycomb": "Akov",
  "item.minecraft.hopper_minecart": "Vakon xchi'uk malobil",
  "item.minecraft.horse_spawn_egg": "Vinajesob ka'",
  "item.minecraft.host_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornamento j-ik'vanej",
  "item.minecraft.howl_pottery_shard": "Xut seramika me'nal-ok'el",
  "item.minecraft.howl_pottery_sherd": "Xut seramika me'nal-ok'el",
  "item.minecraft.husk_spawn_egg": "Vinajesob j-ulel",
  "item.minecraft.ink_sac": "Moral tinta",
  "item.minecraft.iron_axe": "Ek'el",
  "item.minecraft.iron_boots": "Xonob tak'inetik",
  "item.minecraft.iron_chestplate": "Korasa",
  "item.minecraft.iron_golem_spawn_egg": "Vinajesob jchabivanej tak'in",
  "item.minecraft.iron_helmet": "Kasko tak'in",
  "item.minecraft.iron_hoe": "Asaron",
  "item.minecraft.iron_horse_armor": "Almarura sventa ka'",
  "item.minecraft.iron_ingot": "Linkote tak'in",
  "item.minecraft.iron_leggings": "Vex tak'in",
  "item.minecraft.iron_nautilus_armor": "Armarura tak'in sventa navtilo",
  "item.minecraft.iron_nugget": "Bek' tak'in",
  "item.minecraft.iron_pickaxe": "Piko",
  "item.minecraft.iron_shovel": "Pala",
  "item.minecraft.iron_spear": "Lansa tak'in",
  "item.minecraft.iron_sword": "Espara",
  "item.minecraft.item_frame": "Marko",
  "item.minecraft.jungle_boat": "Jabnaltikal varko",
  "item.minecraft.jungle_chest_boat": "Jabnaltikal varko xchi'uk kaxa",
  "item.minecraft.knowledge_book": "Muk'ta vun",
  "item.minecraft.lapis_lazuli": "Lapislasuli",
  "item.minecraft.lava_bucket": "Valte xchi'uk tsuk'",
  "item.minecraft.lead": "Ch'ojon",
  "item.minecraft.leather": "Nukul",
  "item.minecraft.leather_boots": "Nukul xonobiletik",
  "item.minecraft.leather_chestplate": "Nukul tunika",
  "item.minecraft.leather_helmet": "Nukul sna jolil",
  "item.minecraft.leather_horse_armor": "Nukul almarura sventa ka'",
  "item.minecraft.leather_leggings": "Nukul vexil",
  "item.minecraft.light_blue_bundle": "Yaxal moral",
  "item.minecraft.light_blue_dye": "Yaxal bonolil",
  "item.minecraft.light_blue_harness": "Yaxal pek'",
  "item.minecraft.light_gray_bundle": "K'anch'etan moral",
  "item.minecraft.light_gray_dye": "K'anch'etan bonolil",
  "item.minecraft.light_gray_harness": "K'anch'etan pek'",
  "item.minecraft.lime_bundle": "Yoxyoxtik moral",
  "item.minecraft.lime_dye": "Yoxyoxtik bonolil",
  "item.minecraft.lime_harness": "Yaxal pek'",
  "item.minecraft.lingering_potion": "Jalijej poxil",
  "item.minecraft.lingering_potion.effect.awkward": "Mu komon jalijej poxil",
  "item.minecraft.lingering_potion.effect.empty": "Jalijej poxil mu xu' xmeltsaj",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Jalijej poxil ta ts'ik k'ok'",
  "item.minecraft.lingering_potion.effect.harming": "Jalijej poxil ta yaintasel",
  "item.minecraft.lingering_potion.effect.healing": "Jalijej poxil ta poxtael",
  "item.minecraft.lingering_potion.effect.infested": "Jalijej poxil ta xujulal",
  "item.minecraft.lingering_potion.effect.invisibility": "Jalijej poxil ta mu vinajel ta k'elel",
  "item.minecraft.lingering_potion.effect.leaping": "Jalijej poxil ta bitel",
  "item.minecraft.lingering_potion.effect.levitation": "Jalijej poxil ta vilel",
  "item.minecraft.lingering_potion.effect.luck": "Jalijej poxil ta k'inal",
  "item.minecraft.lingering_potion.effect.mundane": "Chopol jalijej poxil",
  "item.minecraft.lingering_potion.effect.night_vision": "Jalijej poxil ta ak'obal ilel",
  "item.minecraft.lingering_potion.effect.oozing": "Jalijej poxil ta similal",
  "item.minecraft.lingering_potion.effect.poison": "Jalijej chopol poxil",
  "item.minecraft.lingering_potion.effect.regeneration": "Jalijej poxil ta cha'vinajesel",
  "item.minecraft.lingering_potion.effect.slow_falling": "Jalijej poxil ta ch'ajil lomel",
  "item.minecraft.lingering_potion.effect.slowness": "Jalijej poxil ta ch'ajilal",
  "item.minecraft.lingering_potion.effect.strength": "Jalijej poxil ta ipal",
  "item.minecraft.lingering_potion.effect.swiftness": "Jalijej poxil ta anilal",
  "item.minecraft.lingering_potion.effect.thick": "Tot jalijej poxil",
  "item.minecraft.lingering_potion.effect.turtle_master": "Jalijej poxil yu'un Jchanubtasvanej Ok",
  "item.minecraft.lingering_potion.effect.water": "Jalijej limeta xchi'uk vo'",
  "item.minecraft.lingering_potion.effect.water_breathing": "Jalijej poxil ta ich'-ik' ta vo'",
  "item.minecraft.lingering_potion.effect.weakness": "Jalijej poxil ta k'unibel",
  "item.minecraft.lingering_potion.effect.weaving": "Jalijej poxil ta jalel",
  "item.minecraft.lingering_potion.effect.wind_charged": "Jalijej poxil ta sutub-ik'",
  "item.minecraft.llama_spawn_egg": "Vinajesob muk'ta chij",
  "item.minecraft.lodestone_compass": "Burujula maknetita",
  "item.minecraft.mace": "Mas",
  "item.minecraft.magenta_bundle": "Tsojtsojtik moral",
  "item.minecraft.magenta_dye": "Tsojtsojtik bonolil",
  "item.minecraft.magenta_harness": "Tsojtsojtik pek'",
  "item.minecraft.magma_cream": "K'ak'al simil",
  "item.minecraft.magma_cube_spawn_egg": "Vinajesob k'ak'al simchon",
  "item.minecraft.mangrove_boat": "Varko ja'alte'",
  "item.minecraft.mangrove_chest_boat": "Varko ja'alte' xchi'uk kaxa",
  "item.minecraft.map": "Pojol mapa",
  "item.minecraft.melon_seeds": "Sbek'tak xancha",
  "item.minecraft.melon_slice": "Jxet' xancha",
  "item.minecraft.milk_bucket": "Valte xchi'uk chu' vakax",
  "item.minecraft.minecart": "Vakon",
  "item.minecraft.miner_pottery_shard": "Xut seramika jok'vanej",
  "item.minecraft.miner_pottery_sherd": "Xut seramika jok'vanej",
  "item.minecraft.mojang_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.mojang_banner_pattern.desc": "K'usi",
  "item.minecraft.mojang_banner_pattern.new": "Lok'tael ta k'usi",
  "item.minecraft.mooshroom_spawn_egg": "Vinajesob mooshroom",
  "item.minecraft.mourner_pottery_shard": "Xut seramika jchabich'en",
  "item.minecraft.mourner_pottery_sherd": "Xut seramika jchabich'en",
  "item.minecraft.mule_spawn_egg": "Vinajesob mula",
  "item.minecraft.mushroom_stew": "Sopa moni'",
  "item.minecraft.music_disc_11": "Risko",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Risko",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Risko",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Risko",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Risko",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Risko",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Risko",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Risko",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Risko",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Risko",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Disc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Risko",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Risko",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Risko",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Risko",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Risko",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Risko",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Risko",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Risko",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Risko",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Risko",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Tse bek'tal chij",
  "item.minecraft.name_tag": "Etiketa",
  "item.minecraft.nautilus_shell": "Spat navtilo",
  "item.minecraft.nautilus_spawn_egg": "Vinajesob navtilo",
  "item.minecraft.nether_brick": "Nether latriyo",
  "item.minecraft.nether_star": "Nether k'anal",
  "item.minecraft.nether_wart": "Nether ch'okte'",
  "item.minecraft.netherite_axe": "Ek'el neterita",
  "item.minecraft.netherite_boots": "Xonob neteritaetik",
  "item.minecraft.netherite_chestplate": "Korasa neterita",
  "item.minecraft.netherite_helmet": "Kasko neterita",
  "item.minecraft.netherite_hoe": "Asaron neterita",
  "item.minecraft.netherite_horse_armor": "Almarura neterita sventa ka'",
  "item.minecraft.netherite_ingot": "Linkote neterita",
  "item.minecraft.netherite_leggings": "Vex neterita",
  "item.minecraft.netherite_nautilus_armor": "Amarura neterita sventa navtilo",
  "item.minecraft.netherite_pickaxe": "Piko neterita",
  "item.minecraft.netherite_scrap": "Xut neterita",
  "item.minecraft.netherite_shovel": "Pala neterita",
  "item.minecraft.netherite_spear": "Lansa neterita",
  "item.minecraft.netherite_sword": "Espara neterita",
  "item.minecraft.netherite_upgrade_smithing_template": "Plantiya tak'inal",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Lekubtasel neterita",
  "item.minecraft.oak_boat": "Varko tulan",
  "item.minecraft.oak_chest_boat": "Varko tulan xchi'uk kaxa",
  "item.minecraft.ocelot_spawn_egg": "Vinajesob k'ox bolom",
  "item.minecraft.ominous_bottle": "Chopol limeta",
  "item.minecraft.ominous_trial_key": "Chopol yavi' tsatsalil",
  "item.minecraft.orange_bundle": "K'onk'ontik moral",
  "item.minecraft.orange_dye": "K'onk'ontik bonolil",
  "item.minecraft.orange_harness": "K'onk'ontik pek'",
  "item.minecraft.painting": "Bonobil",
  "item.minecraft.pale_oak_boat": "Varko sakpak'an tulan",
  "item.minecraft.pale_oak_chest_boat": "Varko sakpak'an tulan xchi'uk kaxa",
  "item.minecraft.panda_spawn_egg": "Vinajesob china oso chon",
  "item.minecraft.paper": "Vun",
  "item.minecraft.parched_spawn_egg": "Vinajesob jtakijel",
  "item.minecraft.parrot_spawn_egg": "Vinajesob puyuch'",
  "item.minecraft.phantom_membrane": "Smemprana muk'ta sots'",
  "item.minecraft.phantom_spawn_egg": "Vinajesob muk'ta sots'",
  "item.minecraft.pig_spawn_egg": "Vinajesob chitom",
  "item.minecraft.piglin_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.piglin_banner_pattern.desc": "Ni' piglin",
  "item.minecraft.piglin_banner_pattern.new": "Lok'tael ta ni' piglin",
  "item.minecraft.piglin_brute_spawn_egg": "Vinajesob xi'el piglin",
  "item.minecraft.piglin_spawn_egg": "Vinajesob piglin",
  "item.minecraft.pillager_spawn_egg": "Vinajesob makbe",
  "item.minecraft.pink_bundle": "Tsojtsojtik moral",
  "item.minecraft.pink_dye": "Tsojtsojtik bonolil",
  "item.minecraft.pink_harness": "Tsojtsojtik pek'",
  "item.minecraft.pitcher_plant": "Binalte'",
  "item.minecraft.pitcher_pod": "Ts'utuj binalte'",
  "item.minecraft.plenty_pottery_shard": "Xut seramika xe'elal",
  "item.minecraft.plenty_pottery_sherd": "Xut seramika xe'elal",
  "item.minecraft.poisonous_potato": "Chamebal isak'",
  "item.minecraft.polar_bear_spawn_egg": "Vinajesob sakil oso chon",
  "item.minecraft.popped_chorus_fruit": "Vobil sat choruste'",
  "item.minecraft.porkchop": "Tse bek'tal chitom",
  "item.minecraft.potato": "Isak'",
  "item.minecraft.potion": "Poxil",
  "item.minecraft.potion.effect.awkward": "Mu komon poxil",
  "item.minecraft.potion.effect.empty": "Poxil mu xu' xmeltsaj",
  "item.minecraft.potion.effect.fire_resistance": "Poxil ta ts'ik k'ok'",
  "item.minecraft.potion.effect.harming": "Poxil ta yaintasel",
  "item.minecraft.potion.effect.healing": "Poxil ta poxtael",
  "item.minecraft.potion.effect.infested": "Poxil ta xujulal",
  "item.minecraft.potion.effect.invisibility": "Poxil ta mu vinajel ta k'elel",
  "item.minecraft.potion.effect.leaping": "Poxil ta bitel",
  "item.minecraft.potion.effect.levitation": "Poxil ta vilel",
  "item.minecraft.potion.effect.luck": "Poxil ta k'inal",
  "item.minecraft.potion.effect.mundane": "Chopol poxil",
  "item.minecraft.potion.effect.night_vision": "Poxil ta ak'obal ilel",
  "item.minecraft.potion.effect.oozing": "Poxil ta similal",
  "item.minecraft.potion.effect.poison": "Chamebal poxil",
  "item.minecraft.potion.effect.regeneration": "Poxil ta cha'vinajesel",
  "item.minecraft.potion.effect.slow_falling": "Poxil ta ch'ajil lomel",
  "item.minecraft.potion.effect.slowness": "Poxil ta ch'ajilal",
  "item.minecraft.potion.effect.strength": "Poxil ta ipal",
  "item.minecraft.potion.effect.swiftness": "Poxil ta anilal",
  "item.minecraft.potion.effect.thick": "Tot poxil",
  "item.minecraft.potion.effect.turtle_master": "Poxil yu'un Jchanubtasvanej Ok",
  "item.minecraft.potion.effect.water": "Limeta xchi'uk vo'",
  "item.minecraft.potion.effect.water_breathing": "Poxil ta ich'-ik' ta vo'",
  "item.minecraft.potion.effect.weakness": "Poxil ta k'unibel",
  "item.minecraft.potion.effect.weaving": "Poxil ta jalel",
  "item.minecraft.potion.effect.wind_charged": "Poxil ta sutub-ik'",
  "item.minecraft.pottery_shard_archer": "Xut seramika j-alkol",
  "item.minecraft.pottery_shard_arms_up": "Xut seramika axinal",
  "item.minecraft.pottery_shard_prize": "Xut seramika me'tak'in",
  "item.minecraft.pottery_shard_skull": "Xut seramika bakil jolil",
  "item.minecraft.powder_snow_bucket": "Valte xchi'uk p'up' taiv",
  "item.minecraft.prismarine_crystals": "Kristal prismarinaetik",
  "item.minecraft.prismarine_shard": "Xut prismarina",
  "item.minecraft.prize_pottery_shard": "Xut seramika me'tak'in",
  "item.minecraft.prize_pottery_sherd": "Xut seramika me'tak'in",
  "item.minecraft.pufferfish": "Ch'ixal choy",
  "item.minecraft.pufferfish_bucket": "Valte xchi'uk ch'ixal choy",
  "item.minecraft.pufferfish_spawn_egg": "Vinajesob ch'ixal choy",
  "item.minecraft.pumpkin_pie": "Pastel ch'um",
  "item.minecraft.pumpkin_seeds": "Sbek'tak ch'um",
  "item.minecraft.purple_bundle": "Ik'pok'an moral",
  "item.minecraft.purple_dye": "Ik'pok'an bonolil",
  "item.minecraft.purple_harness": "Ik'pok'an pek'",
  "item.minecraft.quartz": "Nether kuarso",
  "item.minecraft.rabbit": "Tse bik'tal t'ul",
  "item.minecraft.rabbit_foot": "Yok t'ul",
  "item.minecraft.rabbit_hide": "Nukul t'ul",
  "item.minecraft.rabbit_spawn_egg": "Vinajesob t'ul",
  "item.minecraft.rabbit_stew": "Sopa t'ul",
  "item.minecraft.raiser_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornamento toyesel",
  "item.minecraft.ravager_spawn_egg": "Vinajesob jsokesvanej",
  "item.minecraft.raw_copper": "Lumil k'anal k'unil tak'in",
  "item.minecraft.raw_gold": "Lumil k'anal tak'in",
  "item.minecraft.raw_iron": "Lumil sakil tak'in",
  "item.minecraft.recovery_compass": "Burujula cha'sa'el",
  "item.minecraft.red_bundle": "Tsajal moral",
  "item.minecraft.red_dye": "Tsajal bonolil",
  "item.minecraft.red_harness": "Tsajal pek'",
  "item.minecraft.redstone": "Ts'ub redstone",
  "item.minecraft.resin_brick": "Latriyo xuchꞌ",
  "item.minecraft.resin_clump": "Xuch'",
  "item.minecraft.rib_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornamento ch'ilte'",
  "item.minecraft.rotten_flesh": "K'a'al bek'talil",
  "item.minecraft.saddle": "Xila",
  "item.minecraft.salmon": "Tse bek'tal xalmon",
  "item.minecraft.salmon_bucket": "Valte xchi'uk xalmon",
  "item.minecraft.salmon_spawn_egg": "Vinajesob xalmon",
  "item.minecraft.scrape_pottery_sherd": "Xut seramika jot'el",
  "item.minecraft.scute": "Mik'",
  "item.minecraft.sentry_armor_trim_smithing_template": "Palantiya tak'inal",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornamento jk'el-osil",
  "item.minecraft.shaper_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornamento morelarol",
  "item.minecraft.sheaf_pottery_shard": "Xut seramika kaxlan ixim",
  "item.minecraft.sheaf_pottery_sherd": "Xut seramika kaxlan ixim",
  "item.minecraft.shears": "Texerex",
  "item.minecraft.sheep_spawn_egg": "Vinajesob chij",
  "item.minecraft.shelter_pottery_shard": "Xut seramika tsatsal na",
  "item.minecraft.shelter_pottery_sherd": "Xut seramika tsatsal na",
  "item.minecraft.shield": "Eskuro",
  "item.minecraft.shield.black": "Ik'al eskuro",
  "item.minecraft.shield.blue": "Yaxal eskuro",
  "item.minecraft.shield.brown": "K'anch'etan eskuro",
  "item.minecraft.shield.cyan": "Yax-elan eskuro",
  "item.minecraft.shield.gray": "K'anch'etan eskuro",
  "item.minecraft.shield.green": "Yaxal eskuro",
  "item.minecraft.shield.light_blue": "Yaxal eskuro",
  "item.minecraft.shield.light_gray": "K'anch'etan eskuro",
  "item.minecraft.shield.lime": "Yoxyoxtik eskuro",
  "item.minecraft.shield.magenta": "Tsojtsojtik eskuro",
  "item.minecraft.shield.orange": "K'onk'ontik eskuro",
  "item.minecraft.shield.pink": "Tsojtsojtik eskuro",
  "item.minecraft.shield.purple": "Ik'pok'an eskuro",
  "item.minecraft.shield.red": "Tsajal eskuro",
  "item.minecraft.shield.white": "Sakil eskuro",
  "item.minecraft.shield.yellow": "K'anal eskuro",
  "item.minecraft.shulker_shell": "Spat shulker",
  "item.minecraft.shulker_spawn_egg": "Vinajesob shulker",
  "item.minecraft.sign": "Leterero",
  "item.minecraft.silence_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornamento ch'inetel",
  "item.minecraft.silverfish_spawn_egg": "Vinajesob tonilchoy",
  "item.minecraft.skeleton_horse_spawn_egg": "Vinajesob jich'il ka'",
  "item.minecraft.skeleton_spawn_egg": "Vinajesob jbakubel",
  "item.minecraft.skull_banner_pattern": "Lok'tael yu'un vantera",
  "item.minecraft.skull_banner_pattern.desc": "Bakil jolil",
  "item.minecraft.skull_banner_pattern.new": "Lok'tael ta bakil jolil",
  "item.minecraft.skull_pottery_shard": "Xut seramika bakil jolil",
  "item.minecraft.skull_pottery_sherd": "Xut seramika bakil jolil",
  "item.minecraft.slime_ball": "Bola simil",
  "item.minecraft.slime_spawn_egg": "Vinajesob simchon",
  "item.minecraft.smithing_template": "Plantiya tak'inal",
  "item.minecraft.smithing_template.applies_to": "Chak'be:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ak'o jbej linkote o kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Almarura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ak'o jk'os almarura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Linkoteetik xchi'uk kristaletik",
  "item.minecraft.smithing_template.ingredients": "Skapetik:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Ak'o jbej linkote neterita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "K'usitik pasbil ta riamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ak'o jlik almarura o jtel abtejebal pasbil ta riamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Linkote neterita",
  "item.minecraft.smithing_template.upgrade": "Tslekubtas: ",
  "item.minecraft.sniffer_spawn_egg": "Vinajesob j-uts'ivanej",
  "item.minecraft.snort_pottery_shard": "Xut seramika j-uts'ivanej",
  "item.minecraft.snort_pottery_sherd": "Xut seramika j-uts'ivanej",
  "item.minecraft.snout_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornamento eal",
  "item.minecraft.snow_golem_spawn_egg": "Vinajesob jchabivanej taiv",
  "item.minecraft.snowball": "Bola taiv",
  "item.minecraft.spectral_arrow": "Nop'ol yolob",
  "item.minecraft.spider_eye": "Sat om",
  "item.minecraft.spider_spawn_egg": "Vinajesob om",
  "item.minecraft.spire_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornamento akuxa",
  "item.minecraft.splash_potion": "Jtenbail poxil",
  "item.minecraft.splash_potion.effect.awkward": "Mu komon jtenbail poxil",
  "item.minecraft.splash_potion.effect.empty": "Jtenbail poxil mu xu' xmeltsaj",
  "item.minecraft.splash_potion.effect.fire_resistance": "Jtenbail poxil ta ts'ik k'ok'",
  "item.minecraft.splash_potion.effect.harming": "Jtenbail poxil ta yaintasel",
  "item.minecraft.splash_potion.effect.healing": "Jtenbail poxil ta poxtael",
  "item.minecraft.splash_potion.effect.infested": "Jtenbail poxil ta xujulal",
  "item.minecraft.splash_potion.effect.invisibility": "Jtenbail poxil ta mu vinajel ta k'elel",
  "item.minecraft.splash_potion.effect.leaping": "Jtenbail poxil ta bitel",
  "item.minecraft.splash_potion.effect.levitation": "Jtenbail poxil ta vilel",
  "item.minecraft.splash_potion.effect.luck": "Jtenbail poxil ta k'inal",
  "item.minecraft.splash_potion.effect.mundane": "Chopol jtenbail poxil",
  "item.minecraft.splash_potion.effect.night_vision": "Jtenbail poxil ta ak'obal ilel",
  "item.minecraft.splash_potion.effect.oozing": "Jtenbail poxil ta similal",
  "item.minecraft.splash_potion.effect.poison": "Jtenbail chamebal poxil",
  "item.minecraft.splash_potion.effect.regeneration": "Jtenbail poxil ta cha'vinajesel",
  "item.minecraft.splash_potion.effect.slow_falling": "Jtenbail poxil ta ch'ajil lomel",
  "item.minecraft.splash_potion.effect.slowness": "Jtenbail poxil ta ch'ajilal",
  "item.minecraft.splash_potion.effect.strength": "Jtenbail poxil ta ipal",
  "item.minecraft.splash_potion.effect.swiftness": "Jtenbail poxil ta anilal",
  "item.minecraft.splash_potion.effect.thick": "Jtenbail tot poxil",
  "item.minecraft.splash_potion.effect.turtle_master": "Jtenbail poxil yu'un Jchanubtasvanej Ok",
  "item.minecraft.splash_potion.effect.water": "Jtenbail limeta xchi'uk vo'",
  "item.minecraft.splash_potion.effect.water_breathing": "Jtenbail poxil ta ich'-ik' ta vo'",
  "item.minecraft.splash_potion.effect.weakness": "Jtenbail poxil ta k'unibel",
  "item.minecraft.splash_potion.effect.weaving": "Jtenbail poxil ta jalel",
  "item.minecraft.splash_potion.effect.wind_charged": "Jtenbail poxil ta sutub-ik'",
  "item.minecraft.spruce_boat": "Varko toj",
  "item.minecraft.spruce_chest_boat": "Varko toj xchi'uk kaxa",
  "item.minecraft.spyglass": "Katalejo",
  "item.minecraft.squid_spawn_egg": "Vinajesob muk'ta ja'al-om",
  "item.minecraft.stick": "Te'",
  "item.minecraft.stone_axe": "Ek'el ton",
  "item.minecraft.stone_hoe": "Asaron ton",
  "item.minecraft.stone_pickaxe": "Piko asaron",
  "item.minecraft.stone_shovel": "Pala ton",
  "item.minecraft.stone_spear": "Lansa ton",
  "item.minecraft.stone_sword": "Espara ton",
  "item.minecraft.stray_spawn_egg": "Vinajesob jch'ayel",
  "item.minecraft.strider_spawn_egg": "Vinajesob jxanbal tsuk'",
  "item.minecraft.string": "No",
  "item.minecraft.sugar": "Askal",
  "item.minecraft.suspicious_stew": "Chopol sopa",
  "item.minecraft.sweet_berries": "Chi'il bayaetik",
  "item.minecraft.tadpole_bucket": "Valte xchi'uk avob",
  "item.minecraft.tadpole_spawn_egg": "Vinajesob avob",
  "item.minecraft.tide_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornamento balak'vo'",
  "item.minecraft.tipped_arrow": "Lekubtasbil yolob",
  "item.minecraft.tipped_arrow.effect.awkward": "Lekubtasbil yolob",
  "item.minecraft.tipped_arrow.effect.empty": "Lekubtasbil yolob mu xu' xmeltsaj",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Yolob ta ts'ik k'ok'",
  "item.minecraft.tipped_arrow.effect.harming": "Yolob ta yaintasel",
  "item.minecraft.tipped_arrow.effect.healing": "Yolob ta poxtael",
  "item.minecraft.tipped_arrow.effect.infested": "Yolob ta xujulal",
  "item.minecraft.tipped_arrow.effect.invisibility": "Yolob ta mu vinajel ta k'elel",
  "item.minecraft.tipped_arrow.effect.leaping": "Yolob ta bitel",
  "item.minecraft.tipped_arrow.effect.levitation": "Yolob ta vilel",
  "item.minecraft.tipped_arrow.effect.luck": "Yolob ta k'inal",
  "item.minecraft.tipped_arrow.effect.mundane": "Lekubtasbil yolob",
  "item.minecraft.tipped_arrow.effect.night_vision": "Yolob ta ak'obal ilel",
  "item.minecraft.tipped_arrow.effect.oozing": "Yolob ta similal",
  "item.minecraft.tipped_arrow.effect.poison": "Yolob ta chamebal poxil",
  "item.minecraft.tipped_arrow.effect.regeneration": "Yolob ta cha'vinajesel",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Yolob ta ch'ajil lomel",
  "item.minecraft.tipped_arrow.effect.slowness": "Yolob ta ch'ajilal",
  "item.minecraft.tipped_arrow.effect.strength": "Yolob ta ipal",
  "item.minecraft.tipped_arrow.effect.swiftness": "Yolob ta anilal",
  "item.minecraft.tipped_arrow.effect.thick": "Lekubtasbil yolob",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Yolob yu'un Jchanubtasvanej Ok",
  "item.minecraft.tipped_arrow.effect.water": "Jts'itesvanej yolob",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Yolob ta ich'-ik' ta vo'",
  "item.minecraft.tipped_arrow.effect.weakness": "Yolob ta k'unibel",
  "item.minecraft.tipped_arrow.effect.weaving": "Yolob ta jalel",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Yolob ta sutub-ik'",
  "item.minecraft.tnt_minecart": "Vakon xchi'uk rinamita",
  "item.minecraft.torchflower_seeds": "Sbek'tak nop'olnichim",
  "item.minecraft.totem_of_undying": "Totem ta mu lajelal",
  "item.minecraft.trader_llama_spawn_egg": "Vinajesob muk'ta chij yu'un jchonolajel",
  "item.minecraft.trial_key": "Yavi' tsatsalil",
  "item.minecraft.trident": "Trirente",
  "item.minecraft.tropical_fish": "Jabnaltikal choy",
  "item.minecraft.tropical_fish_bucket": "Valte xchi'uk jabnaltikal choy",
  "item.minecraft.tropical_fish_spawn_egg": "Vinajesob jabnaltikal choy",
  "item.minecraft.turtle_helmet": "Spat ok",
  "item.minecraft.turtle_scute": "Smik'al ok",
  "item.minecraft.turtle_spawn_egg": "Vinajesob ok",
  "item.minecraft.vex_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornamento jsa'sunvanej",
  "item.minecraft.vex_spawn_egg": "Vinajesob jsa'sunvanej",
  "item.minecraft.villager_spawn_egg": "Vinajesob yajval lum",
  "item.minecraft.vindicator_spawn_egg": "Vinajesob jpakvanej",
  "item.minecraft.wandering_trader_spawn_egg": "Vinajesob va'vunajel jchonolajel",
  "item.minecraft.ward_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornamento jchabivanej",
  "item.minecraft.warden_spawn_egg": "Vinajesob jchabich'en",
  "item.minecraft.warped_fungus_on_a_stick": "Te' xchi'uk ts'otol moni'",
  "item.minecraft.water_bucket": "Valte xchi'uk vo'",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornamento jsa'be",
  "item.minecraft.wheat": "Kaxlan ixim",
  "item.minecraft.wheat_seeds": "Sbek'tak kaxlan ixim",
  "item.minecraft.white_bundle": "Sakil moral",
  "item.minecraft.white_dye": "Sakil bonolil",
  "item.minecraft.white_harness": "Sakil pek'",
  "item.minecraft.wild_armor_trim_smithing_template": "Plantiya tak'inal",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Te'tikal ornamento",
  "item.minecraft.wind_charge": "Nojel ik'",
  "item.minecraft.witch_spawn_egg": "Vinajesob chopol ants",
  "item.minecraft.wither_skeleton_spawn_egg": "Vinajesob jbakubel yu'un Wither",
  "item.minecraft.wither_spawn_egg": "Vinajesob Wither",
  "item.minecraft.wolf_armor": "Almarura sventa ok'il",
  "item.minecraft.wolf_spawn_egg": "Vinajesob ok'il",
  "item.minecraft.wooden_axe": "Ek'el te'",
  "item.minecraft.wooden_hoe": "Asaron te'",
  "item.minecraft.wooden_pickaxe": "Piko te'",
  "item.minecraft.wooden_shovel": "Pala te'",
  "item.minecraft.wooden_spear": "Lansa te'",
  "item.minecraft.wooden_sword": "Espara te'",
  "item.minecraft.writable_book": "Vun xchi'uk k'uk'umil",
  "item.minecraft.written_book": "Ts'ibtabil vun",
  "item.minecraft.yellow_bundle": "K'anal moral",
  "item.minecraft.yellow_dye": "K'anal bonolil",
  "item.minecraft.yellow_harness": "K'anal pek'",
  "item.minecraft.zoglin_spawn_egg": "Vinajesob zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Vinajesob chamem ka'",
  "item.minecraft.zombie_nautilus_spawn_egg": "Vinajesob chamem navtilo",
  "item.minecraft.zombie_spawn_egg": "Vinajesob jchamel",
  "item.minecraft.zombie_villager_spawn_egg": "Vinajesob chamem yajval lum",
  "item.minecraft.zombified_piglin_spawn_egg": "Vinajesob ipajesbil piglin"
}
export const tzo_mx = items; 
